<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- HEADER -->
      <div class="page-header">
        <div class="row">
          <div class="col-sm-12 d-flex flex-wrap align-items-center justify-content-between gap-2">
            <div>
              <h3 class="page-title mb-1">Quản lý Xăng Dầu</h3>
              <ul class="breadcrumb mb-0">
                <li class="breadcrumb-item">
                  <router-link to="/">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Xăng Dầu</li>
              </ul>
            </div>

            <!-- Stats nhỏ trên header -->
            <div class="header-stats d-flex flex-wrap justify-content-end">
              <div class="header-stat-pill">
                <span class="label">Đơn chờ duyệt</span>
                <span class="value text-warning">{{ stats.pending }}</span>
              </div>
              <div class="header-stat-pill">
                <span class="label">Đã duyệt</span>
                <span class="value text-success">{{ stats.approved }}</span>
              </div>
              <div class="header-stat-pill">
                <span class="label">Số xe</span>
                <span class="value">{{ stats.carCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Chế độ thời gian -->
      <div class="col-12 col-md-3 mb-3">
        <label class="form-label d-block">Chế độ thời gian</label>
        <div class="btn-group btn-group-sm d-flex" role="group">
          <button
            type="button"
            class="btn"
            :class="filterMode === 'MONTH' ? 'btn-primary' : 'btn-outline-primary'"
            @click="setFilterMode('MONTH')"
          >
            Theo tháng
          </button>
          <button
            type="button"
            class="btn"
            :class="filterMode === 'DATE_RANGE' ? 'btn-primary' : 'btn-outline-primary'"
            @click="setFilterMode('DATE_RANGE')"
          >
            Khoảng ngày
          </button>
        </div>
      </div>

      <!-- FILTER -->
      <div class="card mb-3">
        <div class="card-body">
          <form @submit.prevent="applyFilters" class="row g-3 align-items-end">
            <!-- Lọc theo xe -->
            <div class="col-12 col-md-3">
              <label class="form-label">Lọc theo Xe</label>
              <select
                v-model="filters.xeId"
                class="form-control"
                :disabled="isLoadingOptions"
              >
                <option :value="null">-- Tất cả Xe --</option>
                <option
                  v-for="opt in xeOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.bienSo }}
                </option>
              </select>
            </div>

            <!-- Theo tháng -->
            <div v-if="filterMode === 'MONTH'" class="col-12 col-md-3">
              <label class="form-label">Tháng</label>
              <div class="d-flex align-items-center gap-1">
                <button
                  type="button"
                  class="btn btn-light btn-sm mr-1"
                  @click="changeMonth(-1)"
                >
                  <i class="fa fa-chevron-left"></i>
                </button>
                <input
                  type="month"
                  class="form-control"
                  v-model="monthInput"
                  @change="onMonthChange"
                />
                <button
                  type="button"
                  class="btn btn-light btn-sm ml-1"
                  @click="changeMonth(1)"
                >
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Khoảng ngày -->
            <div v-if="filterMode === 'DATE_RANGE'" class="col-6 col-md-3">
              <label class="form-label">Từ ngày</label>
              <input type="date" class="form-control" v-model="filters.tuNgay" />
            </div>
            <div v-if="filterMode === 'DATE_RANGE'" class="col-6 col-md-3">
              <label class="form-label">Đến ngày</label>
              <input type="date" class="form-control" v-model="filters.denNgay" />
            </div>

            <!-- Nút Lọc -->
            <div class="col-12 col-md-3">
              <button
                type="submit"
                class="btn btn-primary btn-block w-100 mt-2 mt-md-0"
                :disabled="isLoadingList"
              >
                <span
                  v-if="isLoadingList"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                <i v-else class="fa fa-filter mr-1"></i> Lọc
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- TAB TRẠNG THÁI -->
      <div class="card card-tabs mb-3">
        <div class="card-header p-0 border-bottom-0">
          <ul class="nav nav-tabs nav-justified small-tabs">
            <li class="nav-item">
              <a
                href="#"
                class="nav-link"
                :class="{ active: filters.trangThai === 'CHO_DUYET' }"
                @click.prevent="applyFilterTab('CHO_DUYET')"
              >
                <i class="fa fa-clock-o mr-1"></i> Chờ Duyệt
              </a>
            </li>
            <li class="nav-item">
              <a
                href="#"
                class="nav-link"
                :class="{ active: filters.trangThai === 'DA_DUYET' }"
                @click.prevent="applyFilterTab('DA_DUYET')"
              >
                <i class="fa fa-check mr-1 text-success"></i> Đã Duyệt
              </a>
            </li>
            <li class="nav-item">
              <a
                href="#"
                class="nav-link"
                :class="{ active: filters.trangThai === 'DA_THANH_TOAN' }"
                @click.prevent="applyFilterTab('DA_THANH_TOAN')"
              >
                <i class="fa fa-money mr-1 text-info"></i> Đã thanh toán
              </a>
            </li>
            <li class="nav-item">
              <a
                href="#"
                class="nav-link"
                :class="{ active: filters.trangThai === 'TU_CHOI' }"
                @click.prevent="applyFilterTab('TU_CHOI')"
              >
                <i class="fa fa-times mr-1 text-danger"></i> Đã Từ Chối
              </a>
            </li>
          </ul>
        </div>
      </div>


       <!-- TỒN ĐẦU KỲ -->
<div
  class="card mb-2"
  v-if="filters.xeId && filterMode === 'MONTH'"
>
  <div
    class="card-body py-2 d-flex flex-wrap justify-content-between align-items-center"
  >
    <div>
      <div class="small text-muted">
        Tồn đầu kỳ cho tháng {{ displayTonPeriod  }} (chốt cuối tháng trước)
      </div>

      <div v-if="tonDau">
        <div>
          Số lít tồn:
          <strong>
            {{ Number(tonDau.tonDauLit || 0).toLocaleString('vi-VN', { maximumFractionDigits: 2 }) }}
            L
          </strong>
        </div>
        <div>
          ODO chốt:
          <strong>
            {{ Number(tonDau.odoCuoiKy || 0).toLocaleString('vi-VN') }} km
          </strong>
        </div>
        <div v-if="tonDau.ngayChot" class="small text-muted">
          Ngày chốt: {{ tonDau.ngayChot }}
        </div>
        <div v-if="tonDau.ghiChu" class="small text-muted">
          Ghi chú: {{ tonDau.ghiChu }}
        </div>
      </div>

      <div v-else class="text-muted">
        Chưa nhập tồn đầu kỳ cho xe này & tháng này.
      </div>
    </div>

    <div class="mt-2 mt-md-0">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary"
        @click="openTonModal"
      >
        <i class="fa fa-edit mr-1"></i>
        {{ tonDau ? 'Cập nhật tồn đầu kỳ' : 'Nhập tồn đầu kỳ' }}
      </button>
    </div>
  </div>
</div>


      <!-- STATS NHANH -->
      <div class="card mb-2">
        <div class="card-body py-2">
          <div class="row text-center quick-stats-row">
            <div class="col-4 col-md-2 quick-stat-item">
              <div class="label">Tổng đơn</div>
              <div class="value">{{ stats.totalLogs }}</div>
            </div>
            <div class="col-4 col-md-2 quick-stat-item">
              <div class="label">Số xe</div>
              <div class="value">{{ stats.carCount }}</div>
            </div>
            <div class="col-4 col-md-2 quick-stat-item">
              <div class="label">Tổng tiền</div>
              <div class="value text-danger">{{ formatCurrency(stats.sumSoTien) }}</div>
            </div>
            <div class="col-4 col-md-2 quick-stat-item">
              <div class="label">Tổng lít</div>
              <div class="value">{{ stats.sumSoLit.toLocaleString('vi-VN') }} L</div>
            </div>
            <div class="col-4 col-md-2 quick-stat-item">
              <div class="label">Đơn giá TB</div>
              <div class="value">{{ formatCurrency(stats.avgDonGia) }}/L</div>
            </div>
            <div class="col-4 col-md-2 quick-stat-item">
              <div class="label">Km thực tế</div>
              <div class="value text-primary">{{ stats.sumKmThucTe.toLocaleString('vi-VN') }} km</div>
            </div>
          </div>
        </div>
      </div>



      <!-- Thống kê cẩu -->
      <div class="card mb-2" v-if="isSelectedXeCau">
        <div class="card-body py-2">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <div class="font-weight-bold">
              <i class="fa fa-industry mr-1"></i>
              Thời gian dùng cẩu (theo xe)
            </div>

            <div class="d-flex align-items-center">
              <small v-if="!filters.xeId" class="text-muted mr-2">
                Chọn 1 Xe để xem thống kê cẩu
              </small>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="loadCauData"
                :disabled="isLoadingCauSummary || !filters.xeId"
              >
                <i
                  class="fa"
                  :class="isLoadingCauSummary ? 'fa-spinner fa-spin' : 'fa-refresh'"
                ></i>
              </button>
            </div>
          </div>

          <!-- Các state khác nhau -->
          <div v-if="!filters.xeId" class="small text-muted">
            Vui lòng chọn 1 Xe ở bộ lọc phía trên để xem thời gian dùng cẩu.
          </div>

          <div v-else-if="isLoadingCauSummary" class="small text-muted">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Đang tải thống kê cẩu...
          </div>

          <div v-else-if="cauSummaryError" class="small text-danger">
            <i class="fa fa-exclamation-circle mr-1"></i>{{ cauSummaryError }}
          </div>

          <div v-else-if="!cauSummary" class="small text-muted">
            Không có dữ liệu cẩu trong khoảng thời gian lọc.
          </div>

          <div v-else>
            <div class="row small mb-2">
              <div class="col-6 col-md-3 mb-1">
                <div class="text-muted">Xe</div>
                <div class="font-weight-bold">
                  {{ cauSummary.xeBienSo || ('#' + (cauSummary.xeId || filters.xeId)) }}
                </div>
              </div>

              <div class="col-6 col-md-3 mb-1">
                <div class="text-muted">Tổng thời gian cẩu</div>
                <div class="font-weight-bold">
                  {{ Math.floor(cauSummary.totalHours || (cauSummary.totalMinutes || 0) / 60) }} giờ
                  {{ (cauSummary.totalMinutes || 0) % 60 }} phút
                </div>
              </div>

              <div class="col-6 col-md-3 mb-1">
                <div class="text-muted">Quy đổi xăng</div>
                <div class="font-weight-bold text-primary">
                  {{
                    Number(
                      cauSummary.estimatedLiters ?? cauSummary.estimatedLiters ?? 0
                    ).toLocaleString('vi-VN', { maximumFractionDigits: 1 })
                  }} L
                </div>
              </div>

              <div class="col-6 col-md-3 mb-1">
                <div class="text-muted">Km quy đổi từ cẩu</div>
                <div class="font-weight-bold text-primary">
                  {{ cauKmFromSummary.toLocaleString('vi-VN', { maximumFractionDigits: 1 }) }} km
                </div>
              </div>
            </div>

            <div class="small text-muted mb-2">
              Km thực tế (ODO) trong bảng xăng hiện tại:
              <strong>{{ stats.sumKmThucTe.toLocaleString('vi-VN') }} km</strong><br />
              Cộng thêm Km quy đổi từ cẩu:
              <strong class="text-success">
                {{ sumKmThucTeWithCau.toLocaleString('vi-VN', { maximumFractionDigits: 1 }) }} km
              </strong>
            </div>

            <!-- Phiên cẩu gần đây -->
            <div class="small mt-2">
              <div class="font-weight-bold mb-1">
                <i class="fa fa-history mr-1"></i> Phiên cẩu gần đây
              </div>

              <div v-if="isLoadingCauSessions" class="text-muted">
                <span class="spinner-border spinner-border-sm mr-1"></span>
                Đang tải danh sách phiên cẩu...
              </div>

              <div v-else-if="cauSessionsError" class="text-danger">
                <i class="fa fa-exclamation-circle mr-1"></i>{{ cauSessionsError }}
              </div>

              <div v-else-if="!cauSessions.length" class="text-muted">
                Chưa có phiên cẩu nào trong khoảng thời gian lọc.
              </div>

              <ul v-else class="list-unstyled mb-0">
                <li
                  v-for="s in cauSessions.slice(0, 5)"
                  :key="s.id"
                  class="mb-1"
                >
                  <strong>#{{ s.id }}</strong>
                  •
                  {{ formatDateTime(s.startedAt || s.createdAt) }}
                  <span v-if="s.endedAt">
                    → {{ formatDateTime(s.endedAt) }}
                  </span>
                  <span v-else class="text-danger"> (chưa đóng)</span>
                  • {{ s.durationMinutes || 0 }} phút
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- LIST + EXPORT -->
      <div class="card">
        <div class="card-body p-0">
          <!-- Toolbar -->
          <div class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom toolbar">
            <div class="text-muted small">
              Danh sách log xăng dầu ({{ items.length }} dòng trên trang)
            </div>
           <div class="btn-group btn-group-sm">
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="openAdminCreateModal"
              >
                <i class="fa fa-plus mr-1"></i> Tạo phiếu thủ công
              </button>

              <button
                type="button"
                class="btn btn-success"
                @click="exportToExcel"
                :disabled="isLoadingList || !items.length"
              >
                <i class="fa fa-file-excel-o mr-1"></i> Xuất Excel
              </button>
            </div>
          </div>

          <!-- States list -->
          <div
            v-if="isLoadingList && items.length === 0"
            class="p-4 text-center"
          >
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 mb-0 text-muted">Đang tải lịch sử...</p>
          </div>

          <div
            v-else-if="listError && items.length === 0"
            class="alert alert-danger m-3"
          >
            <i class="fa fa-exclamation-triangle mr-2"></i> {{ listError }}
          </div>

          <div v-else-if="items.length === 0" class="p-4 text-center text-muted">
            Không tìm thấy log xăng dầu nào.
          </div>

          <!-- Table -->
          <div v-else class="table-responsive">
            <table class="table table-hover table-striped mb-0 table-sm-mobile">
              <thead class="thead-light">
                <tr>
                  <th>Ngày đổ</th>
                  <th>Tài xế</th>
                  <th>Xe</th>
                  <th class="text-right">Số Tiền</th>
                  <th class="text-right">Số Lít</th>
                  <th class="text-right">Đơn Giá</th>
                  <th class="text-right d-none d-sm-table-cell">Km Lần trước</th>
                  <th class="text-right d-none d-sm-table-cell">Km Lần này</th>
                  <th class="text-right">Km Thực Tế</th>
                  <th class="text-right d-none d-md-table-cell">Km định vị</th>
                  <th>Trạng thái</th>
                  <th class="text-right">Duyệt</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="log in items"
                  :key="log.id"
                  @click="openDetail(log.id)"
                  style="cursor: pointer;"
                >
                  <td>{{ formatDateTime(log.ngayDo) }}</td>
                  <td class="text-truncate max-w-120">{{ log.tenTaiXe }}</td>
                  <td><strong>{{ log.xeBienSo }}</strong></td>
                  <td class="text-right font-weight-bold text-danger">
                    {{ formatCurrency(log.soTien) }}
                  </td>
                  <td class="text-right">{{ log.soLit }} L</td>
                  <td class="text-right">{{ formatCurrency(log.donGia) }}</td>
                  <td class="text-right d-none d-sm-table-cell">{{ log.odoKmDauKy }}</td>
                  <td class="text-right d-none d-sm-table-cell">{{ log.odoKmCuoiKy }}</td>
                  <td class="text-right text-primary font-weight-bold">
                    {{ displayKmThucTe(log) }}
                  </td>

                  <!-- Km định vị -->
                  <td class="text-right d-none d-md-table-cell" @click.stop>
                    <template v-if="gpsMap[log.id]">
                      <span
                        v-if="gpsMap[log.id].loading"
                        class="text-muted small"
                      >
                        Đang lấy…
                      </span>
                      <span
                        v-else-if="gpsMap[log.id].error"
                        class="text-danger small"
                      >
                        -
                      </span>
                      <span
                        v-else-if="gpsMap[log.id].km != null"
                        class="text-primary font-weight-bold"
                      >
                        {{ gpsMap[log.id].km.toLocaleString('vi-VN', { maximumFractionDigits: 1 }) }}
                      </span>
                      <span v-else class="text-muted small">-</span>
                    </template>
                    <template v-else>
                      <span class="text-muted small">Đang chờ...</span>
                    </template>
                  </td>

                  <td>
                    <span class="badge" :class="getStatusBadge(log.trangThai)">
                      {{ formatTrangThai(log.trangThai) }}
                    </span>
                  </td>
                  <td class="text-right">
                    <button
                      class="btn btn-sm btn-outline-primary"
                      @click.stop="openDetail(log.id)"
                    >
                      <i class="fa fa-eye"></i> Xem
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="totalPages > 1"
            class="p-3 d-flex justify-content-between align-items-center border-top"
          >
            <small class="text-muted">
              Tổng: {{ totalElements }} bản ghi — Trang
              {{ currentPage }}/{{ totalPages }}
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li
                class="page-item"
                :class="{ disabled: currentPage === 1 }"
              >
                <a
                  href="#"
                  class="page-link"
                  @click.prevent="goPage(currentPage - 1)"
                >
                  «
                </a>
              </li>

              <li
                v-for="p in pageList"
                :key="p"
                class="page-item"
                :class="{ active: p === currentPage }"
              >
                <a
                  href="#"
                  class="page-link"
                  @click.prevent="goPage(p)"
                >
                  {{ p }}
                </a>
              </li>

              <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages }"
              >
                <a
                  href="#"
                  class="page-link"
                  @click.prevent="goPage(currentPage + 1)"
                >
                  »
                </a>
              </li>
            </ul>

          </div>
        </div>
      </div>

      <!-- Modal chi tiết -->
      <div
        v-if="showModal"
        class="modal fade show d-block"
        tabindex="-1"
        style="background: rgba(0,0,0,.5);"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header bg-light">
              <h5
                class="modal-title font-weight-bold"
                v-if="currentLogDetail"
              >
                <i class="fa fa-gas-pump mr-2"></i>
                Chi tiết Đổ xăng #{{ currentLogDetail.id }}
              </h5>
              <h5 v-else class="modal-title font-weight-bold">Đang tải...</h5>
              <button type="button" class="close" @click="closeModal">
                <span>&times;</span>
              </button>
            </div>

            <div v-if="isLoadingDetail" class="modal-body text-center py-5">
              <div
                class="spinner-border text-primary"
                style="width: 3rem; height: 3rem;"
              ></div>
            </div>

            <div v-else-if="detailError" class="modal-body">
              <div class="alert alert-danger">{{ detailError }}</div>
            </div>

            <div v-else-if="currentLogDetail" class="modal-body">
              <div
                v-if="formError"
                class="alert alert-danger py-2"
              >
                {{ formError }}
              </div>

              <div class="row">
                <!-- Cột trái -->
                <div class="col-lg-6 border-right mb-3 mb-lg-0">
                  <h5 class="mb-3">Thông tin Báo cáo</h5>
                  <table class="table table-sm table-bordered">
                    <tbody>
                      <tr>
                        <td style="width: 150px;">Trạng thái</td>
                        <td>
                          <span
                            class="badge"
                            :class="getStatusBadge(currentLogDetail.trangThai)"
                          >
                            {{ formatTrangThai(currentLogDetail.trangThai) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Tài xế</td>
                        <td><strong>{{ currentLogDetail.tenTaiXe }}</strong></td>
                      </tr>
                      <tr>
                        <td>Xe</td>
                        <td><strong>{{ currentLogDetail.xeBienSo }}</strong></td>
                      </tr>
                      <tr>
                        <td>Thời điểm đổ</td>
                        <td>{{ formatDateTime(currentLogDetail.ngayDo) }}</td>
                      </tr>
                      <tr>
                        <td>Ghi chú</td>
                        <td><strong>{{ currentLogDetail.ghiChu }}</strong></td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Bằng chứng -->
                  <h5 class="mt-4 mb-3">Bằng chứng (Tài xế gửi)</h5>
                  <div class="row">
                    <!-- Biên lai -->
                    <div class="col-md-6 mb-3">
                      <label class="d-block text-center mb-2">Ảnh Biên lai</label>
                      <div
                        v-if="currentLogDetail.bienLaiUrls && currentLogDetail.bienLaiUrls.length"
                        class="evidence-list"
                      >
                        <div
                          v-for="(url, idx) in currentLogDetail.bienLaiUrls"
                          :key="'bl-' + idx"
                          class="evidence-item"
                        >
                          <img
                            :src="url"
                            class="evidence-thumb rounded border"
                            :alt="'Biên lai ' + (idx + 1)"
                            @click.stop="openEvidence('BIEN_LAI', idx)"
                          />
                          <div class="small text-muted mt-1">
                            {{ idx === 0 ? 'Ảnh chính' : ('Ảnh ' + (idx + 1)) }}
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-center">
                        <img
                          :src="currentLogDetail.anhBienLaiUrl || '/assets/img/placeholder.png'"
                          class="evidence-thumb-single rounded border"
                          alt="Biên lai"
                          @click.stop="openEvidence('BIEN_LAI', 0)"
                        />
                        <div class="small text-muted mt-1">Ảnh chính</div>
                      </div>
                    </div>

                    <!-- ODO -->
                    <div class="col-md-6 mb-3">
                      <label class="d-block text-center mb-2">Ảnh Đồng hồ ODO</label>
                      <div
                        v-if="currentLogDetail.odoUrls && currentLogDetail.odoUrls.length"
                        class="evidence-list"
                      >
                        <div
                          v-for="(url, idx) in currentLogDetail.odoUrls"
                          :key="'odo-' + idx"
                          class="evidence-item"
                        >
                          <img
                            :src="url"
                            class="evidence-thumb rounded border"
                            :alt="'ODO ' + (idx + 1)"
                            @click.stop="openEvidence('ODO', idx)"
                          />
                          <div class="small text-muted mt-1">
                            {{ idx === 0 ? 'Ảnh chính' : ('Ảnh ' + (idx + 1)) }}
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-center">
                        <img
                          :src="currentLogDetail.anhOdoUrl || '/assets/img/placeholder.png'"
                          class="evidence-thumb-single rounded border"
                          alt="ODO"
                          @click.stop="openEvidence('ODO', 0)"
                        />
                        <div class="small text-muted mt-1">Ảnh chính</div>
                      </div>
                    </div>
                  </div>

                  <!-- Thông tin thanh toán -->
                  <h5 class="mt-4 mb-2">
                    <i class="fa fa-money mr-1"></i> Thông tin Thanh toán
                  </h5>

                  <div v-if="currentLogDetail.trangThai !== 'DA_THANH_TOAN'" class="text-muted small">
                    Chưa thanh toán.
                  </div>
                  <div v-else>
                    <table class="table table-sm table-bordered mb-2">
                      <tbody>
                        <tr>
                          <td style="width: 150px;">Người thanh toán</td>
                          <td><strong>{{ currentLogDetail.tenNguoiThanhToan || '—' }}</strong></td>
                        </tr>
                        <tr>
                          <td>Thời điểm thanh toán</td>
                          <td>{{ formatDateTime(currentLogDetail.thoiDiemThanhToan) }}</td>
                        </tr>
                        <tr>
                          <td>Ghi chú</td>
                          <td>{{ currentLogDetail.ghiChuThanhToan || '-' }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div v-if="currentLogDetail.anhChuyenKhoanUrl" class="text-center">
                      <img
                        :src="currentLogDetail.anhChuyenKhoanUrl"
                        alt="Ảnh chuyển khoản"
                        class="evidence-thumb-single rounded border"
                        style="max-height: 220px; cursor: zoom-in;"
                        @click.stop="openLightboxFromList([currentLogDetail.anhChuyenKhoanUrl], 0)"
                      />
                    </div>
                  </div>

                  <!-- Lịch sử chỉnh sửa -->
                  <div class="mt-4">
                    <h5 class="mb-2">
                      <i class="fa fa-history mr-1"></i> Lịch sử chỉnh sửa
                    </h5>

                    <div v-if="isLoadingHistory" class="text-muted">
                      <span class="spinner-border spinner-border-sm"></span> Đang tải…
                    </div>

                    <div v-else-if="historyError" class="alert alert-danger py-2">{{ historyError }}</div>

                    <div v-else-if="!editHistory.length" class="text-muted">
                      Chưa có lần chỉnh sửa nào.
                    </div>

                    <div v-else class="table-responsive">
                      <table class="table table-sm table-bordered mb-0">
                        <thead class="thead-light">
                          <tr>
                            <th style="white-space:nowrap;">Thời điểm</th>
                            <th>Người sửa</th>
                            <th>Lý do</th>
                            <th>Trước → Sau</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="h in editHistory" :key="h.id">
                            <td style="white-space:nowrap;">{{ formatDateTime(h.editedAt) }}</td>
                            <td>{{ h.tenNguoiSua || ('ID: ' + h.editorId) }}</td>
                            <td class="text-wrap">{{ h.lyDo }}</td>
                            <td class="text-wrap">
                              <div><strong>Số tiền:</strong> {{ formatCurrency(h.soTienTruoc) }} → {{ formatCurrency(h.soTienSau) }}</div>
                              <div><strong>Số lít:</strong> {{ h.soLitTruoc }} → {{ h.soLitSau }}</div>
                              <div><strong>Đơn giá:</strong> {{ formatCurrency(h.donGiaTruoc) }}/L → {{ formatCurrency(h.donGiaSau) }}/L</div>
                              <div><strong>Km đầu kỳ:</strong> {{ h.odoKmDauKyTruoc }} → {{ h.odoKmDauKySau }}</div>
                              <div><strong>Km cuối kỳ:</strong> {{ h.odoKmCuoiKyTruoc }} → {{ h.odoKmCuoiKySau }}</div>
                              <div>
                                <strong>Ngày đổ:</strong>
                                {{ h.ngayDoTruoc ? formatDateTime(h.ngayDoTruoc) : '-' }} →
                                {{ h.ngayDoSau ? formatDateTime(h.ngayDoSau) : '-' }}
                              </div>
                              <div><strong>Ghi chú:</strong> {{ h.ghiChuTruoc || '-' }} → {{ h.ghiChuSau || '-' }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Cột phải -->
                <div class="col-lg-6">
                  <h5 class="mb-3">Chi tiết Tính toán</h5>
                  <table class="table table-sm table-bordered">
                    <tbody>
                      <tr>
                        <td style="width: 150px;">Số Tiền</td>
                        <td class="font-weight-bold text-danger">
                          {{ formatCurrency(currentLogDetail.soTien) }}
                        </td>
                      </tr>
                      <tr>
                        <td>Số Lít</td>
                        <td>{{ currentLogDetail.soLit }} L</td>
                      </tr>
                      <tr>
                        <td>Đơn Giá (Tự tính)</td>
                        <td>{{ formatCurrency(currentLogDetail.donGia) }} / Lít</td>
                      </tr>
                      <tr>
                        <td>Km Đầu Kỳ (Lần trước)</td>
                        <td>{{ currentLogDetail.odoKmDauKy }} km</td>
                      </tr>
                      <tr>
                        <td>Km Cuối Kỳ (Lần này)</td>
                        <td><strong>{{ currentLogDetail.odoKmCuoiKy }} km</strong></td>
                      </tr>
                      <tr>
                        <td>Km Thực Tế (Đã chạy)</td>
                        <td class="font-weight-bold text-primary">
                          {{ displayKmThucTe(currentLogDetail) }} km
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="mt-3 d-flex flex-wrap gap-2">
                    <button
                      v-if="currentLogDetail.trangThai === 'CHO_DUYET'"
                      type="button"
                      class="btn btn-success"
                      :disabled="isLoadingDetail"
                      @click="doApprove(currentLogDetail.id)"
                    >
                      <span v-if="isLoadingDetail" class="spinner-border spinner-border-sm"></span>
                      <i v-else class="fa fa-check"></i> Duyệt (Hợp lệ)
                    </button>

                    <button
                      v-if="currentLogDetail.trangThai === 'CHO_DUYET'"
                      type="button"
                      class="btn btn-danger"
                      :disabled="isLoadingDetail"
                      @click="doReject(currentLogDetail.id)"
                    >
                      <span v-if="isLoadingDetail" class="spinner-border spinner-border-sm"></span>
                      <i v-else class="fa fa-times"></i> Từ chối
                    </button>

                    <!-- Nút xác nhận thanh toán -->
                    <button
                      v-if="currentLogDetail.trangThai === 'DA_DUYET'"
                      type="button"
                      class="btn btn-info"
                      :disabled="isLoadingDetail"
                      @click="openPaymentForm(currentLogDetail)"
                    >
                      <i class="fa fa-money"></i> Xác nhận thanh toán
                    </button>

                    <!-- Nút mở form chỉnh sửa -->
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      :disabled="isLoadingDetail || !currentLogDetail"
                      @click="openEditForm(currentLogDetail)"
                    >
                      <i class="fa fa-edit"></i> Chỉnh sửa
                    </button>
                  </div>

                  <div
                    v-if="currentLogDetail.trangThai === 'DA_DUYET'"
                    class="mt-4 alert alert-success"
                  >
                    Đã duyệt bởi:
                    <strong>{{ currentLogDetail.tenNguoiDuyet }}</strong>
                    lúc {{ formatDateTime(currentLogDetail.thoiDiemDuyet) }}.
                  </div>

                  <div
                    v-if="currentLogDetail.trangThai === 'TU_CHOI'"
                    class="mt-4 alert alert-danger"
                  >
                    Đã từ chối bởi:
                    <strong>{{ currentLogDetail.tenNguoiDuyet }}</strong><br />
                    Lý do: {{ currentLogDetail.ghiChu }}
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeModal"
              >
                Đóng
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal CHỈNH SỬA -->
      <div
        v-if="editModal.show"
        class="modal fade show d-block"
        tabindex="-1"
        style="background: rgba(0,0,0,.5);"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <form @submit.prevent="submitEdit">
              <div class="modal-header bg-light">
                <h5 class="modal-title font-weight-bold">
                  <i class="fa fa-edit mr-2"></i> Chỉnh sửa Báo cáo #{{ editModal.form.id }}
                </h5>
                <button type="button" class="close" @click="closeEditForm">
                  <span>&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div v-if="editModal.error" class="alert alert-danger py-2">{{ editModal.error }}</div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Số tiền (đ)</label>
                      <input type="number" class="form-control" v-model.number="editModal.form.soTien" min="1" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Đơn giá (đ/lít)</label>
                      <input type="number" class="form-control" step="0.01" min="0.01" v-model.number="editModal.form.donGia" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Số lít</label>
                      <input type="number" class="form-control" step="0.01" min="0.01" v-model.number="editModal.form.soLit" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>ODO đầu kỳ</label>
                      <input
                        type="number"
                        class="form-control"
                        step="0.01"
                        min="0"
                        v-model.number="editModal.form.odoKmDauKy"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>ODO cuối kỳ</label>
                      <input type="number" class="form-control" step="0.01" min="1" v-model.number="editModal.form.odoKmCuoiKy" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Thời điểm đổ</label>
                      <input type="datetime-local" class="form-control" v-model="editModal.form.ngayDo" />
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label>Ghi chú mới</label>
                      <textarea class="form-control" rows="2" v-model.trim="editModal.form.ghiChu"></textarea>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label class="font-weight-bold text-danger">Lý do chỉnh sửa <span class="text-danger">*</span></label>
                      <textarea class="form-control" rows="2" v-model.trim="editModal.form.lyDo" required></textarea>
                      <small class="form-text text-muted">Bắt buộc, phục vụ kiểm tra và audit.</small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-light" @click="closeEditForm">Hủy</button>
                <button type="submit" class="btn btn-primary" :disabled="editModal.submitting">
                  <span v-if="editModal.submitting" class="spinner-border spinner-border-sm"></span>
                  <i v-else class="fa fa-save"></i> Lưu chỉnh sửa
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>


      <!-- Modal TỒN ĐẦU KỲ XĂNG DẦU -->
      <div
        v-if="tonModal.show"
        class="modal fade show d-block"
        tabindex="-1"
        style="background: rgba(0,0,0,.5);"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <form @submit.prevent="submitTonDau">
              <div class="modal-header bg-warning">
                <h5 class="modal-title font-weight-bold">
                  <i class="fa fa-database mr-1"></i> Tồn đầu kỳ
                </h5>
                <button
                  type="button"
                  class="close"
                  @click="tonModal.show = false"
                  :disabled="tonModal.submitting"
                >
                  <span>&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div class="form-group">
                  <label>Xe</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="selectedXe ? selectedXe.bienSo : ('ID ' + tonModal.form.xeId)"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label>Tồn đầu (lít)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    class="form-control"
                    v-model.number="tonModal.form.tonDauLit"
                  />
                </div>

                <div class="form-row">
                  <div class="form-group col-6">
                    <label>Đơn giá tồn (đ/lít)</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="tonModal.form.donGiaTonText"
                      @input="onTonNumberInput('donGiaTon', $event)"
                    />
                  </div>
                  <div class="form-group col-6">
                    <label>Số tiền tồn (đ)</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="tonModal.form.soTienTonText"
                      @input="onTonNumberInput('soTienTon', $event)"
                    />
                  </div>
                </div>


                <div class="form-group">
                  <label>ODO chốt (km)</label>
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model.number="tonModal.form.odoCuoiKy"
                  />
                </div>

                <div class="form-group">
                  <label>Ngày chốt</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="tonModal.form.ngayChot"
                  />
                </div>

                <div class="form-group">
                  <label>Ghi chú</label>
                  <textarea
                    rows="2"
                    class="form-control"
                    v-model.trim="tonModal.form.ghiChu"
                  ></textarea>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="tonModal.show = false"
                  :disabled="tonModal.submitting"
                >
                  Hủy
                </button>
                <button
                  type="submit"
                  class="btn btn-warning"
                  :disabled="tonModal.submitting"
                >
                  <span
                    v-if="tonModal.submitting"
                    class="spinner-border spinner-border-sm mr-1"
                  ></span>
                  Lưu tồn đầu kỳ
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>



      <!-- Modal THANH TOÁN -->
      <div
        v-if="paymentModal.show"
        class="modal fade show d-block"
        tabindex="-1"
        style="background: rgba(0,0,0,.5);"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <form @submit.prevent="submitPayment">
              <div class="modal-header bg-info text-white">
                <h5 class="modal-title font-weight-bold">
                  <i class="fa fa-credit-card mr-2"></i> Xác nhận Thanh toán
                  <span v-if="paymentModal.form.id" class="small ml-2">
                    (#{{ paymentModal.form.id }})
                  </span>
                </h5>
                <button
                  type="button"
                  class="close text-white"
                  @click="closePaymentModal"
                  :disabled="paymentModal.submitting || paymentModal.isUploading"
                >
                  <span>&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div v-if="paymentModal.uploadError" class="alert alert-danger py-2">
                  {{ paymentModal.uploadError }}
                </div>

                <div class="form-group">
                  <label>Ghi chú thanh toán</label>
                  <textarea
                    v-model.trim="paymentModal.form.ghiChuThanhToan"
                    class="form-control"
                    rows="2"
                    placeholder="VD: Đã chuyển khoản, kiểm tra sao kê ngày 17/11..."
                  ></textarea>
                </div>

                <div class="form-group">
                  <label class="required-label d-flex justify-content-between align-items-center">
                    <span>Ảnh chuyển khoản <span class="text-danger">*</span></span>
                    <span class="small text-muted font-italic">
                      Ctrl+V / Chọn file từ máy
                    </span>
                  </label>

                  <div class="d-flex flex-column flex-md-row align-items-start">
                    <div class="mr-md-2 mb-2 mb-md-0">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="triggerPaymentFileSelect"
                        :disabled="paymentModal.isUploading"
                      >
                        <i class="fa fa-upload mr-1"></i> Chọn ảnh từ máy
                      </button>

                      <input
                        ref="paymentFileInput"
                        type="file"
                        accept="image/*"
                        class="d-none"
                        @change="handlePaymentFileChange"
                      />

                      <div class="small text-muted mt-1">
                        Hỗ trợ JPG, PNG... tối đa vài MB.
                      </div>
                    </div>

                    <div
                      class="upload-dropzone flex-fill mt-2 mt-md-0"
                      tabindex="0"
                      @click="$event.currentTarget.focus()"
                      @paste.prevent="handlePaymentPaste"
                      :class="{ 'is-uploading': paymentModal.isUploading }"
                    >
                      <div class="small">
                        <div v-if="paymentPreviewSource">
                          <div
                            class="preview-thumb clickable-thumb position-relative"
                            @click.stop="openLightboxFromList([paymentPreviewSource], 0)"
                          >
                            <button
                              type="button"
                              class="btn btn-sm btn-danger preview-remove-btn"
                              @click.stop="clearPaymentImage"
                              :disabled="paymentModal.isUploading"
                              title="Xóa ảnh này"
                            >
                              <i class="fa fa-times"></i>
                            </button>

                            <img
                              :src="paymentPreviewSource"
                              class="img-fluid rounded border"
                              style="max-height: 160px; object-fit: cover;"
                              alt="Ảnh chuyển khoản"
                            />
                          </div>

                          <div class="small text-primary mt-1">
                            <i class="fa fa-search-plus mr-1"></i>
                            Nhấn để phóng to
                          </div>
                        </div>

                        <div v-else-if="!paymentModal.isUploading" class="text-muted">
                          <i class="fa fa-clipboard mr-1"></i>
                          Click vào đây rồi dùng <strong>Ctrl+V</strong> để dán ảnh từ
                          clipboard, hoặc dùng nút <strong>Chọn ảnh từ máy</strong>.
                        </div>

                        <div v-if="paymentModal.isUploading" class="small text-muted mt-1">
                          <span class="spinner-border spinner-border-sm"></span>
                          Đang upload ảnh...
                        </div>
                      </div>
                    </div>
                  </div>

                  <small class="form-text text-muted mt-1">
                    Ảnh nên chụp rõ nội dung giao dịch, thời gian, số tiền.
                  </small>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="closePaymentModal"
                  :disabled="paymentModal.submitting || paymentModal.isUploading"
                >
                  Hủy
                </button>
                <button
                  type="submit"
                  class="btn btn-info"
                  :disabled="paymentModal.submitting || paymentModal.isUploading"
                >
                  <span
                    v-if="paymentModal.submitting"
                    class="spinner-border spinner-border-sm mr-1"
                  ></span>
                  Xác nhận Thanh toán
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Modal TẠO PHIẾU THỦ CÔNG (ADMIN) -->
<div
  v-if="adminCreateModal.show"
  class="modal fade show d-block"
  tabindex="-1"
  style="background: rgba(0,0,0,.5);"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content shadow-lg border-0">
      <form @submit.prevent="submitAdminCreate">
        <!-- HEADER -->
        <div class="modal-header bg-primary text-white">
          <div>
            <h5 class="modal-title font-weight-bold d-flex align-items-center mb-0">
              <i class="fa fa-gas-pump mr-2"></i>
              Tạo phiếu xăng dầu thủ công
            </h5>
            <small class="d-block mt-1 text-white-50">
              Dùng khi cần nhập phiếu từ sổ tay / hóa đơn giấy hoặc hệ thống ngoài.
            </small>
          </div>
          <button
            type="button"
            class="close text-white"
            @click="closeAdminCreateModal"
            :disabled="adminCreateModal.submitting"
          >
            <span>&times;</span>
          </button>
        </div>

        <!-- BODY -->
        <div class="modal-body">
          <div
            v-if="adminCreateModal.error"
            class="alert alert-danger py-2 mb-3"
          >
            <i class="fa fa-exclamation-triangle mr-1"></i>
            {{ adminCreateModal.error }}
          </div>

          <!-- SECTION 1: THÔNG TIN CHUNG -->
          <div class="mb-3">
            <div class="d-flex align-items-center mb-2">
              <span class="badge badge-primary mr-2">
                1
              </span>
              <h6 class="mb-0 text-uppercase text-muted font-weight-bold" style="letter-spacing: .5px;">
                Thông tin chung
              </h6>
            </div>

            <div class="card border-0 shadow-sm">
              <div class="card-body pt-3 pb-2">
                <div class="form-row">
                  <!-- Xe -->
                  <div class="form-group col-md-6">
                    <label class="font-weight-500">
                      Xe <span class="text-danger">*</span>
                    </label>
                    <select
                      v-model="adminCreateModal.form.xeId"
                      class="form-control"
                    >
                      <option :value="null">-- Chọn xe --</option>
                      <option
                        v-for="opt in xeOptions"
                        :key="opt.id"
                        :value="opt.id"
                      >
                        {{ opt.bienSo }}
                        <span v-if="opt.tenLoaiXe"> - {{ opt.tenLoaiXe }}</span>
                      </option>
                    </select>
                  </div>

                  <!-- Tài xế -->
                  <div class="form-group col-md-6">
                    <label class="font-weight-500">
                      Tài xế (nếu biết)
                    </label>
                    <select
                      v-model="adminCreateModal.form.taiXeId"
                      class="form-control"
                    >
                      <option :value="null">-- Không gắn tài xế --</option>
                      <option
                        v-for="tx in taiXeOptions"
                        :key="tx.id"
                        :value="tx.id"
                      >
                        {{ tx.hoTen }} (ID: {{ tx.id }})
                      </option>
                    </select>
                    <small class="text-muted">
                      Có thể bỏ trống, dùng khi chưa rõ tài xế chính xác.
                    </small>
                  </div>
                </div>

                <div class="form-row">
                  <!-- Thời điểm đổ -->
                  <div class="form-group col-md-6 mb-2">
                    <label class="font-weight-500">
                      Thời điểm đổ
                    </label>
                    <input
                      type="datetime-local"
                      class="form-control"
                      v-model="adminCreateModal.form.ngayDo"
                    />
                    <small class="text-muted">
                      Nếu bỏ trống, hệ thống tự dùng thời điểm hiện tại.
                    </small>
                  </div>

                  <!-- ODO cuối kỳ -->
                  <div class="form-group col-md-6 mb-2">
                    <label class="font-weight-500">
                      ODO cuối kỳ (km) <span class="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      step="0.01"
                      class="form-control"
                      v-model.number="adminCreateModal.form.odoKmCuoiKy"
                    />
                    <small class="text-muted">
                      Lấy đúng số km sau khi đổ xăng (hình ODO phải khớp).
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SECTION 2: CHI TIẾT ĐỔ XĂNG -->
          <div class="mb-3">
            <div class="d-flex align-items-center mb-2">
              <span class="badge badge-success mr-2">
                2
              </span>
              <h6 class="mb-0 text-uppercase text-muted font-weight-bold" style="letter-spacing: .5px;">
                Chi tiết đổ xăng
              </h6>
            </div>

            <div class="card border-0 shadow-sm">
              <div class="card-body pt-3 pb-2">
                <div class="form-row">

                                    <!-- Đơn giá -->
                  <div class="form-group col-md-4">
                    <label class="font-weight-500">
                      Đơn giá (đ/L)
                    </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fa fa-calculator"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        :value="adminCreateModal.form.donGiaText"
                        @input="onAdminMoneyInput('donGia', $event)"
                        placeholder="VD: 19.820"
                      />
                    </div>
                    <small class="text-muted">
                      Có thể bỏ trống, hệ thống tự tính = Số tiền / Số lít.
                    </small>
                  </div>

                                    <!-- Số lít -->
                  <div class="form-group col-md-4">
                    <label class="font-weight-500">
                      Số lít (L) <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fa fa-tint"></i>
                        </span>
                      </div>
                      <input
                        type="number"
                        step="0.01"
                        min="0.01"
                        class="form-control"
                        v-model.number="adminCreateModal.form.soLit"
                        placeholder="VD: 150.5"
                      />
                    </div>
                  </div>
                  <!-- Số tiền -->
                  <div class="form-group col-md-4">
                    <label class="font-weight-500">
                      Số tiền (đ) <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fa fa-money"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        :value="adminCreateModal.form.soTienText"
                        @input="onAdminMoneyInput('soTien', $event)"
                        placeholder="VD: 3.000.000"
                      />
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>

          <!-- SECTION 3: ẢNH CHỨNG TỪ -->
          <div class="mb-3">
            <div class="d-flex align-items-center mb-2">
              <span class="badge badge-warning mr-2">
                3
              </span>
              <h6 class="mb-0 text-uppercase text-muted font-weight-bold" style="letter-spacing: .5px;">
                Ảnh chứng từ
              </h6>
            </div>

            <div class="card border-0 shadow-sm">
              <div class="card-body pt-3 pb-1">
                <div class="form-row">
                  <!-- Ảnh biên lai -->
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <label class="required-label d-flex justify-content-between align-items-center font-weight-500">
                        <span>
                          Ảnh biên lai <span class="text-danger">*</span>
                        </span>
                        <span class="small text-muted font-italic">
                          Ctrl+V / Chọn file từ máy
                        </span>
                      </label>

                      <div
                        v-if="adminCreateModal.bienLaiUploadError"
                        class="alert alert-danger py-1 mb-2"
                      >
                        {{ adminCreateModal.bienLaiUploadError }}
                      </div>

                      <div class="d-flex flex-column flex-md-row align-items-start">
                        <!-- Nút chọn file -->
                        <div class="mr-md-2 mb-2 mb-md-0">
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            @click="triggerAdminBienLaiFileSelect"
                            :disabled="adminCreateModal.isUploadingBienLai"
                          >
                            <i class="fa fa-upload mr-1"></i> Chọn ảnh từ máy
                          </button>

                          <input
                            ref="adminBienLaiFileInput"
                            type="file"
                            accept="image/*"
                            class="d-none"
                            @change="handleAdminBienLaiFileChange"
                          />

                          <div class="small text-muted mt-1">
                            Hỗ trợ JPG, PNG... tối đa vài MB.
                          </div>
                        </div>

                        <!-- Khu drop / paste -->
                        <div
                          class="upload-dropzone flex-fill mt-2 mt-md-0"
                          tabindex="0"
                          @click="$event.currentTarget.focus()"
                          @paste.prevent="handleAdminBienLaiPaste"
                          :class="{ 'is-uploading': adminCreateModal.isUploadingBienLai }"
                        >
                          <div class="small">
                            <div v-if="adminCreateModal.bienLaiPreviewSource">
                              <div
                                class="preview-thumb clickable-thumb position-relative"
                                @click.stop="openLightboxFromList([adminCreateModal.bienLaiPreviewSource], 0)"
                              >
                                <button
                                  type="button"
                                  class="btn btn-sm btn-danger preview-remove-btn"
                                  @click.stop="clearAdminBienLaiImage"
                                  :disabled="adminCreateModal.isUploadingBienLai"
                                  title="Xóa ảnh này"
                                >
                                  <i class="fa fa-times"></i>
                                </button>

                                <img
                                  :src="adminCreateModal.bienLaiPreviewSource"
                                  class="img-fluid rounded border"
                                  style="max-height: 160px; object-fit: cover;"
                                  alt="Ảnh biên lai"
                                />
                              </div>

                              <div class="small text-primary mt-1">
                                <i class="fa fa-search-plus mr-1"></i>
                                Nhấn để phóng to
                              </div>
                            </div>

                            <div
                              v-else-if="!adminCreateModal.isUploadingBienLai"
                              class="text-muted"
                            >
                              <i class="fa fa-clipboard mr-1"></i>
                              Click vào đây rồi dùng <strong>Ctrl+V</strong> để dán ảnh từ
                              clipboard, hoặc dùng nút <strong>Chọn ảnh từ máy</strong>.
                            </div>

                            <div
                              v-if="adminCreateModal.isUploadingBienLai"
                              class="small text-muted mt-1"
                            >
                              <span class="spinner-border spinner-border-sm"></span>
                              Đang upload ảnh biên lai...
                            </div>
                          </div>
                        </div>
                      </div>

                      <small class="form-text text-muted mt-1">
                        Ảnh nên chụp rõ cây xăng, số tiền, số lít, thời gian giao dịch.
                      </small>
                    </div>
                  </div>

                  <!-- Ảnh ODO -->
                  <div class="col-md-6">
                    <div class="form-group mb-3">
                      <label class="required-label d-flex justify-content-between align-items-center font-weight-500">
                        <span>
                          Ảnh ODO (đồng hồ km) <span class="text-danger">*</span>
                        </span>
                        <span class="small text-muted font-italic">
                          Ctrl+V / Chọn file từ máy
                        </span>
                      </label>

                      <div
                        v-if="adminCreateModal.odoUploadError"
                        class="alert alert-danger py-1 mb-2"
                      >
                        {{ adminCreateModal.odoUploadError }}
                      </div>

                      <div class="d-flex flex-column flex-md-row align-items-start">
                        <!-- Nút chọn file -->
                        <div class="mr-md-2 mb-2 mb-md-0">
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            @click="triggerAdminOdoFileSelect"
                            :disabled="adminCreateModal.isUploadingOdo"
                          >
                            <i class="fa fa-upload mr-1"></i> Chọn ảnh từ máy
                          </button>

                          <input
                            ref="adminOdoFileInput"
                            type="file"
                            accept="image/*"
                            class="d-none"
                            @change="handleAdminOdoFileChange"
                          />

                          <div class="small text-muted mt-1">
                            Hỗ trợ JPG, PNG... tối đa vài MB.
                          </div>
                        </div>

                        <!-- Khu drop / paste -->
                        <div
                          class="upload-dropzone flex-fill mt-2 mt-md-0"
                          tabindex="0"
                          @click="$event.currentTarget.focus()"
                          @paste.prevent="handleAdminOdoPaste"
                          :class="{ 'is-uploading': adminCreateModal.isUploadingOdo }"
                        >
                          <div class="small">
                            <div v-if="adminCreateModal.odoPreviewSource">
                              <div
                                class="preview-thumb clickable-thumb position-relative"
                                @click.stop="openLightboxFromList([adminCreateModal.odoPreviewSource], 0)"
                              >
                                <button
                                  type="button"
                                  class="btn btn-sm btn-danger preview-remove-btn"
                                  @click.stop="clearAdminOdoImage"
                                  :disabled="adminCreateModal.isUploadingOdo"
                                  title="Xóa ảnh này"
                                >
                                  <i class="fa fa-times"></i>
                                </button>

                                <img
                                  :src="adminCreateModal.odoPreviewSource"
                                  class="img-fluid rounded border"
                                  style="max-height: 160px; object-fit: cover;"
                                  alt="Ảnh ODO"
                                />
                              </div>

                              <div class="small text-primary mt-1">
                                <i class="fa fa-search-plus mr-1"></i>
                                Nhấn để phóng to
                              </div>
                            </div>

                            <div
                              v-else-if="!adminCreateModal.isUploadingOdo"
                              class="text-muted"
                            >
                              <i class="fa fa-clipboard mr-1"></i>
                              Click vào đây rồi dùng <strong>Ctrl+V</strong> để dán ảnh từ
                              clipboard, hoặc dùng nút <strong>Chọn ảnh từ máy</strong>.
                            </div>

                            <div
                              v-if="adminCreateModal.isUploadingOdo"
                              class="small text-muted mt-1"
                            >
                              <span class="spinner-border spinner-border-sm"></span>
                              Đang upload ảnh ODO...
                            </div>
                          </div>
                        </div>
                      </div>

                      <small class="form-text text-muted mt-1">
                        Ảnh nên chụp rõ số km trên đồng hồ, tránh lóa / mờ, không che mất số.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SECTION 4: GHI CHÚ -->
          <div>
            <div class="d-flex align-items-center mb-2">
              <span class="badge badge-secondary mr-2">
                4
              </span>
              <h6 class="mb-0 text-uppercase text-muted font-weight-bold" style="letter-spacing: .5px;">
                Ghi chú thêm
              </h6>
            </div>

            <div class="card border-0 shadow-sm">
              <div class="card-body pt-3 pb-2">
                <div class="form-group mb-2">
                  <label class="font-weight-500">Ghi chú</label>
                  <textarea
                    class="form-control"
                    rows="2"
                    v-model.trim="adminCreateModal.form.ghiChu"
                    placeholder="VD: Đổ ca đêm, có giảm giá; hoặc ghi chú khác phục vụ đối soát..."
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div class="modal-footer bg-light">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="closeAdminCreateModal"
            :disabled="adminCreateModal.submitting"
          >
            Hủy
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="adminCreateModal.submitting"
          >
            <span
              v-if="adminCreateModal.submitting"
              class="spinner-border spinner-border-sm mr-1"
            ></span>
            Lưu phiếu
          </button>
        </div>
      </form>
    </div>
  </div>
</div>



      <!-- LIGHTBOX -->
      <VueEasyLightbox
        :visible="lb.visible"
        :imgs="lb.imgs"
        :index="lb.index"
        @hide="lb.visible = false"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia';
import { useAdminXangDauStore } from '@/stores/adminXangDauStore';
import VueEasyLightbox from 'vue-easy-lightbox';
import * as XLSX from 'xlsx-js-style';
import { formatDate, formatDateTime } from '@/helpers/datetime';
import { XangDauApi } from '@/services/xangDauService';
import fileService from '@/services/fileService';
const MAX_GPS_RANGE_MS = 3 * 24 * 60 * 60 * 1000; // 3 ngày

function formatCurrency(value) {
  if (value == null || isNaN(Number(value))) return '-';
  return Number(value).toLocaleString('vi-VN') + ' đ';
}

export default {
  name: 'QuanLyXangDau',
  components: { VueEasyLightbox },
  data() {
    return {
      filters: {
        xeId: null,
        thang: null,
        tuNgay: null,
        denNgay: null,
        trangThai: 'CHO_DUYET',
      },
      showModal: false,
      formError: null,

      filterMode: 'MONTH',
      monthInput: null,

      lb: { visible: false, imgs: [], index: 0 },

      editModal: {
        show: false,
        submitting: false,
        uploading: false,
        error: null,
        localFiles: [],
        form: {
          id: null,
          soTien: null,
          soLit: null,
          odoKmDauKy: null,
          odoKmCuoiKy: null,
          ngayDo: null,
          ghiChu: '',
          lyDo: '',
          anhUrls: [],
        },
      },

adminCreateModal: {
  show: false,
  submitting: false,
  error: null,
  isUploadingBienLai: false,
  isUploadingOdo: false,
  bienLaiUploadError: null,
  odoUploadError: null,
  bienLaiPreviewSource: null,
  odoPreviewSource: null,
  form: {
    xeId: null,
    taiXeId: null,
    ngayDo: null,
    soTien: null,
    soTienText: '',     // <<== text hiển thị tiền
    soLit: null,
    donGia: null,
    donGiaText: '',     // <<== text hiển thị đơn giá
    odoKmCuoiKy: null,
    anhBienLaiUrl: '',
    anhOdoUrl: '',
    ghiChu: '',
  },
},






      gpsMap: {},

      gpsConfig: {
        username: '61h06971\u2003',
        password: '12345',
      },

      cauSummary: null,
      isLoadingCauSummary: false,
      cauSummaryError: null,

      cauSessions: [],
      isLoadingCauSessions: false,
      cauSessionsError: null,

      paymentModal: {
        show: false,
        submitting: false,
        isUploading: false,
        uploadError: null,
        form: {
          id: null,
          ghiChuThanhToan: '',
          anhChuyenKhoanUrl: null,
        },
      },

      paymentPreviewSource: null,
      statsFull: null,    
      tonDau: null,
          tonCuoi: null,

    tonLoading: false,
    tonError: null,
    tonChuaChot: false,
    tonModal: {
      show: false,
      submitting: false,
      form: {
        xeId: null,
        tonDauLit: null,

        // bản hiển thị có dấu
        donGiaTon: null,
        donGiaTonText: '',
        soTienTon: null,
        soTienTonText: '',

        odoCuoiKy: null,
        ngayChot: null,
        ghiChu: '',
      },
    },



    };
  },
  computed: {
    ...mapState(useAdminXangDauStore, [
      'isLoadingList',
      'listError',
      'items',
      'totalPages',
      'totalElements',
      'size',
      'page',
      'isLoadingDetail',
      'detailError',
      'currentLogDetail',
      'isLoadingOptions',
      'xeOptions',
      'taiXeOptions',
      'editHistory',
      'isLoadingHistory',
      'historyError',
      'isSubmittingCorrection',
      'submitCorrectionError',
    ]),
    ...mapGetters(useAdminXangDauStore, ['currentPage']),

    pageSize: {
      get() {
        return this.size;
      },
      set(v) {
        this.changeSize(v);
      },
    },

    // Tồn dầu
    displayMonthLabel() {
  if (!this.monthInput) return '';
  const [y, m] = this.monthInput.split('-');
  return `${m}/${y}`;
},

displayTonPeriod() {
  if (!this.monthInput) return '';
  const [yearStr, monthStr] = this.monthInput.split('-');
  const year = parseInt(yearStr, 10);
  const month = parseInt(monthStr, 10);
  if (!year || !month) return '';

  let prevMonth = month - 1;
  let prevYear = year;
  if (prevMonth < 1) {
    prevMonth = 12;
    prevYear = year - 1;
  }
  return `Chốt cuối tháng ${prevMonth}/${prevYear}`;
},

    pageList() {
    const pages = [];
    const total = this.totalPages || 1;
    const current = this.currentPage || 1;

    // đơn giản: nếu <= 7 trang thì show hết, nhiều hơn thì show window quanh current
    if (total <= 7) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      let start = Math.max(1, current - 3);
      let end = Math.min(total, current + 3);

      if (start === 1) end = 7;
      if (end === total) start = total - 6;

      for (let i = start; i <= end; i++) pages.push(i);
    }

    return pages;
  },

    selectedXe() {
      if (!this.filters.xeId || !this.xeOptions) return null;
      return this.xeOptions.find((x) => x.id === this.filters.xeId) || null;
    },

    // Chỉ true nếu là xe cẩu
    isSelectedXeCau() {
      return this.isCauXeOption(this.selectedXe);
    },

    /**
     * Map logId -> Km thực tế (tự tính lại trên FE)
     * - group theo biển số
     * - sort theo ngày đổ tăng dần
     * - Km của mỗi log = ODO cuối kỳ của bản ghi tiếp theo - ODO cuối kỳ hiện tại
     * - log cuối cùng của 1 xe: km = 0
     */
kmThucTeMap() {
  const map = {};
  const groups = {};

  // Group log theo biển số
  (this.items || []).forEach((log) => {
    if (!log || !log.id || !log.xeBienSo) return;
    const key = this.normalizePlate(log.xeBienSo);
    if (!groups[key]) groups[key] = [];
    groups[key].push(log);
  });

  Object.values(groups).forEach((list) => {
    // sort theo ngày + id tăng dần
    list.sort((a, b) => {
      const ta = new Date(a.ngayDo || 0).getTime();
      const tb = new Date(b.ngayDo || 0).getTime();
      if (ta !== tb) return ta - tb;
      return (a.id || 0) - (b.id || 0);
    });

    for (let i = 0; i < list.length; i++) {
      const cur = list[i];
      const next = list[i + 1];

      // Km xuất phát luôn là Km lần trước của dòng hiện tại
      const startOdo = Number(cur.odoKmDauKy || 0);
      let endOdo = startOdo;

      if (next) {
        // Dòng không phải cuối: dùng Km lần trước của dòng sau (logic cũ)
        endOdo = Number(next.odoKmDauKy || 0);
      } else {
        // Dòng cuối: dùng Km lần này của chính dòng đó
        endOdo = Number(cur.odoKmCuoiKy || 0);
      }

      let km = endOdo - startOdo;
      if (!Number.isFinite(km) || km < 0) km = 0;

      map[cur.id] = km;
    }
  });

  return map;
},



    stats() {
      // Nếu đã có statsFull (tính từ full list theo filter), ưu tiên dùng
      if (this.statsFull) {
        return this.statsFull;
      }

      // Fallback: tính theo trang hiện tại (this.items)
      const KM_PER_LITER = 4;
      const res = {
        totalLogs: 0,
        pending: 0,
        approved: 0,
        rejected: 0,
        carCount: 0,
        sumSoTien: 0,
        sumSoLit: 0,
        avgDonGia: 0,
        sumKmThucTe: 0,
        sumKmPhaiDi: 0,
      };

      const list = this.items || [];
      const carSet = new Set();

      list.forEach((log) => {
        if (!log) return;

        res.totalLogs += 1;

        if (log.trangThai === 'CHO_DUYET') res.pending += 1;
        else if (log.trangThai === 'DA_DUYET') res.approved += 1;
        else if (log.trangThai === 'TU_CHOI') res.rejected += 1;

        if (log.xeBienSo) carSet.add(log.xeBienSo);

        const soTien = Number(log.soTien || 0);
        const soLit = Number(log.soLit || 0);
        const kmTT = Number(this.kmThucTeMap?.[log.id] ?? log.kmThucTe ?? 0);

        res.sumSoTien += soTien;
        res.sumSoLit += soLit;
        res.sumKmThucTe += kmTT;
        res.sumKmPhaiDi += soLit * KM_PER_LITER;
      });

      res.carCount = carSet.size;
      res.avgDonGia =
        res.sumSoLit > 0 ? Math.round(res.sumSoTien / res.sumSoLit) : 0;
      return res;
    },

    // Km quy đổi từ cẩu
    cauKmFromSummary() {
      if (!this.cauSummary) return 0;
      const KM_PER_LITER = 4;

      const totalLit = Number(
        this.cauSummary.estimatedLiters ??
          this.cauSummary.totalLit ??
          this.cauSummary.totalFuelLit ??
          0,
      );

      if (totalLit > 0) {
        return totalLit * KM_PER_LITER;
      }

      const minutes = Number(this.cauSummary.totalMinutes || 0);
      if (!minutes) return 0;
      const hours = minutes / 60;
      const litFromHours = hours * 5;
      return litFromHours * KM_PER_LITER;
    },

    sumKmThucTeWithCau() {
      return this.stats.sumKmThucTe + this.cauKmFromSummary;
    },
  },

  watch: {
    items: {
      handler(newList) {
        this.prefetchGpsForAll(newList);
      },
      immediate: false,
    },
  },

  methods: {
    ...mapActions(useAdminXangDauStore, [
      'fetchList',
      'setPage',
      'setSize',
      'applyFiltersAndFetch',
      'fetchOptionsIfNeeded',
      'fetchLogDetail',
      'clearLogDetail',
      'approveLog',
      'rejectLog',
      'correctLog',
      'fetchEditHistory',
      'uploadEditEvidence',
    ]),

    // Kiểm tra tonDau có đúng là "chốt cuối tháng trước" của tháng đang chọn không
  isTonDauMatchCurrentMonth(ton) {
    if (!ton || !ton.ngayChot || !this.monthInput) return false;

    // Tháng đang chọn, dạng 'YYYY-MM'
    const [yearStr, monthStr] = this.monthInput.split('-');
    const curYear = parseInt(yearStr, 10);
    const curMonth = parseInt(monthStr, 10);
    if (!curYear || !curMonth) return false;

    // Tháng chốt tồn phải là tháng trước
    let expectedMonth = curMonth - 1;
    let expectedYear = curYear;
    if (expectedMonth < 1) {
      expectedMonth = 12;
      expectedYear -= 1;
    }

    const d = new Date(ton.ngayChot);
    if (Number.isNaN(d.getTime())) return false;

    const tonYear = d.getFullYear();
    const tonMonth = d.getMonth() + 1; // JS: 0-based

    return tonYear === expectedYear && tonMonth === expectedMonth;
  },

    // ====== UPLOAD ẢNH ODO (ADMIN CREATE) ======
triggerAdminOdoFileSelect() {
  if (this.adminCreateModal.isUploadingOdo) return;
  if (this.$refs.adminOdoFileInput) {
    this.$refs.adminOdoFileInput.click();
  }
},

async handleAdminOdoFileChange(event) {
  const file = event.target.files && event.target.files[0];
  if (!file) return;

  await this.processAdminOdoImageFile(file);
  event.target.value = '';
},

async handleAdminOdoPaste(event) {
  if (this.adminCreateModal.isUploadingOdo) return;

  const clipboardData = event.clipboardData || window.clipboardData;
  if (!clipboardData) {
    this.adminCreateModal.odoUploadError =
      'Trình duyệt không hỗ trợ dán ảnh từ clipboard.';
    return;
  }

  let file = null;

  if (clipboardData.items && clipboardData.items.length) {
    for (const item of clipboardData.items) {
      if (item.kind === 'file' && item.type.startsWith('image/')) {
        file = item.getAsFile();
        break;
      }
    }
  }

  if (!file && clipboardData.files && clipboardData.files.length) {
    const candidate = clipboardData.files[0];
    if (candidate.type && candidate.type.startsWith('image/')) {
      file = candidate;
    }
  }

  if (!file) {
    this.adminCreateModal.odoUploadError =
      'Clipboard không có ảnh. Vui lòng copy ảnh rồi dán lại.';
    return;
  }

  await this.processAdminOdoImageFile(file);
},

async processAdminOdoImageFile(file) {
  if (!file.type || !file.type.startsWith('image/')) {
    this.adminCreateModal.odoUploadError = 'Chỉ chấp nhận file ảnh.';
    return;
  }

  this.adminCreateModal.odoUploadError = null;
  this.adminCreateModal.isUploadingOdo = true;

  if (
    this.adminCreateModal.odoPreviewSource &&
    this.adminCreateModal.odoPreviewSource.startsWith('blob:')
  ) {
    URL.revokeObjectURL(this.adminCreateModal.odoPreviewSource);
  }
  this.adminCreateModal.odoPreviewSource = URL.createObjectURL(file);

  try {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('folderName', 'xang_dau_odo'); // hoặc 'xang_dau' tùy ông muốn gom

    const response = await fileService.upload(formData);

    if (!response.data || !response.data.length || !response.data[0].location) {
      throw new Error('Upload thành công nhưng không nhận được URL');
    }

    const uploadedUrl = response.data[0].location;

    // set URL vào form để BE nhận
    this.adminCreateModal.form.anhOdoUrl = uploadedUrl;

    if (
      this.adminCreateModal.odoPreviewSource &&
      this.adminCreateModal.odoPreviewSource.startsWith('blob:')
    ) {
      URL.revokeObjectURL(this.adminCreateModal.odoPreviewSource);
    }
    this.adminCreateModal.odoPreviewSource = uploadedUrl;
  } catch (err) {
    console.error('Lỗi upload ảnh ODO:', err);
    this.adminCreateModal.odoUploadError =
      'Upload ảnh ODO thất bại, vui lòng thử lại.';
    this.adminCreateModal.form.anhOdoUrl = null;

    if (
      this.adminCreateModal.odoPreviewSource &&
      this.adminCreateModal.odoPreviewSource.startsWith('blob:')
    ) {
      URL.revokeObjectURL(this.adminCreateModal.odoPreviewSource);
    }
    this.adminCreateModal.odoPreviewSource = null;
  } finally {
    this.adminCreateModal.isUploadingOdo = false;
  }
},

clearAdminOdoImage() {
  if (
    this.adminCreateModal.odoPreviewSource &&
    this.adminCreateModal.odoPreviewSource.startsWith('blob:')
  ) {
    URL.revokeObjectURL(this.adminCreateModal.odoPreviewSource);
  }

  this.adminCreateModal.odoPreviewSource = null;
  this.adminCreateModal.form.anhOdoUrl = null;
  this.adminCreateModal.odoUploadError = null;

  if (this.$refs.adminOdoFileInput) {
    this.$refs.adminOdoFileInput.value = '';
  }
},

      // ====== UPLOAD ẢNH BIÊN LAI (ADMIN CREATE) ======
  triggerAdminBienLaiFileSelect() {
    if (this.adminCreateModal.isUploadingBienLai) return;
    if (this.$refs.adminBienLaiFileInput) {
      this.$refs.adminBienLaiFileInput.click();
    }
  },

  async handleAdminBienLaiFileChange(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    await this.processAdminBienLaiImageFile(file);
    event.target.value = '';
  },

  async handleAdminBienLaiPaste(event) {
    if (this.adminCreateModal.isUploadingBienLai) return;

    const clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData) {
      this.adminCreateModal.bienLaiUploadError =
        'Trình duyệt không hỗ trợ dán ảnh từ clipboard.';
      return;
    }

    let file = null;

    if (clipboardData.items && clipboardData.items.length) {
      for (const item of clipboardData.items) {
        if (item.kind === 'file' && item.type.startsWith('image/')) {
          file = item.getAsFile();
          break;
        }
      }
    }

    if (!file && clipboardData.files && clipboardData.files.length) {
      const candidate = clipboardData.files[0];
      if (candidate.type && candidate.type.startsWith('image/')) {
        file = candidate;
      }
    }

    if (!file) {
      this.adminCreateModal.bienLaiUploadError =
        'Clipboard không có ảnh. Vui lòng copy ảnh rồi dán lại.';
      return;
    }

    await this.processAdminBienLaiImageFile(file);
  },

  async processAdminBienLaiImageFile(file) {
    if (!file.type || !file.type.startsWith('image/')) {
      this.adminCreateModal.bienLaiUploadError = 'Chỉ chấp nhận file ảnh.';
      return;
    }

    this.adminCreateModal.bienLaiUploadError = null;
    this.adminCreateModal.isUploadingBienLai = true;

    // clear preview cũ
    if (
      this.adminCreateModal.bienLaiPreviewSource &&
      this.adminCreateModal.bienLaiPreviewSource.startsWith('blob:')
    ) {
      URL.revokeObjectURL(this.adminCreateModal.bienLaiPreviewSource);
    }
    this.adminCreateModal.bienLaiPreviewSource = URL.createObjectURL(file);

    try {
      const formData = new FormData();
      formData.append('files', file);
      formData.append('folderName', 'xang_dau'); // hoặc 'xang_dau_bien_lai' nếu ông muốn tách folder

      const response = await fileService.upload(formData);

      if (
        !response.data ||
        !response.data.length ||
        !response.data[0].location
      ) {
        throw new Error('Upload thành công nhưng không nhận được URL');
      }

      const uploadedUrl = response.data[0].location;

      // set URL vào form để BE nhận
      this.adminCreateModal.form.anhBienLaiUrl = uploadedUrl;

      // hiển thị preview bằng URL thật (khỏi giữ blob)
      if (
        this.adminCreateModal.bienLaiPreviewSource &&
        this.adminCreateModal.bienLaiPreviewSource.startsWith('blob:')
      ) {
        URL.revokeObjectURL(this.adminCreateModal.bienLaiPreviewSource);
      }
      this.adminCreateModal.bienLaiPreviewSource = uploadedUrl;
    } catch (err) {
      console.error('Lỗi upload ảnh biên lai:', err);
      this.adminCreateModal.bienLaiUploadError =
        'Upload ảnh biên lai thất bại, vui lòng thử lại.';
      this.adminCreateModal.form.anhBienLaiUrl = null;

      if (
        this.adminCreateModal.bienLaiPreviewSource &&
        this.adminCreateModal.bienLaiPreviewSource.startsWith('blob:')
      ) {
        URL.revokeObjectURL(this.adminCreateModal.bienLaiPreviewSource);
      }
      this.adminCreateModal.bienLaiPreviewSource = null;
    } finally {
      this.adminCreateModal.isUploadingBienLai = false;
    }
  },

  clearAdminBienLaiImage() {
    if (
      this.adminCreateModal.bienLaiPreviewSource &&
      this.adminCreateModal.bienLaiPreviewSource.startsWith('blob:')
    ) {
      URL.revokeObjectURL(this.adminCreateModal.bienLaiPreviewSource);
    }

    this.adminCreateModal.bienLaiPreviewSource = null;
    this.adminCreateModal.form.anhBienLaiUrl = null;
    this.adminCreateModal.bienLaiUploadError = null;

    if (this.$refs.adminBienLaiFileInput) {
      this.$refs.adminBienLaiFileInput.value = '';
    }
  },

    onAdminMoneyInput(field, e) {
    const raw = e.target.value;

    if (raw === '') {
      this.adminCreateModal.form[field] = null;
      this.adminCreateModal.form[`${field}Text`] = '';
      return;
    }

    const num = this.parseNumberVN(raw);
    this.adminCreateModal.form[field] = num;

    // nếu parse fail thì giữ nguyên user gõ
    if (num == null) {
      this.adminCreateModal.form[`${field}Text`] = raw;
    } else {
      this.adminCreateModal.form[`${field}Text`] = this.formatNumberVN(num);
    }
  },

    onAdminMoneyInput(field, event) {
    const raw = event.target.value || '';
    // Giữ lại để hiển thị (sẽ format lại phía dưới)
    let cleaned = raw.replace(/[^\d]/g, ''); // chỉ giữ số

    if (!cleaned) {
      // Xóa input => reset giá trị
      if (field === 'soTien') {
        this.adminCreateModal.form.soTien = null;
        this.adminCreateModal.form.soTienText = '';
      } else if (field === 'donGia') {
        this.adminCreateModal.form.donGia = null;
        this.adminCreateModal.form.donGiaText = '';
      }
      return;
    }

    const value = Number(cleaned);
    const form = this.adminCreateModal.form;
    const soLit = Number(form.soLit || 0);

    if (field === 'soTien') {
      // Cập nhật số tiền + text
      form.soTien = value;
      form.soTienText = this.formatNumberVN(value);

      // Nếu đã có số lít > 0 thì tự tính đơn giá
      if (soLit > 0) {
        const donGia = Math.round(value / soLit); // VND / lít
        form.donGia = donGia;
        form.donGiaText = this.formatNumberVN(donGia);
      }
    } else if (field === 'donGia') {
      // Cập nhật đơn giá + text
      form.donGia = value;
      form.donGiaText = this.formatNumberVN(value);

      // Nếu đã có số lít > 0 thì tự tính số tiền
      if (soLit > 0) {
        const soTien = Math.round(value * soLit);
        form.soTien = soTien;
        form.soTienText = this.formatNumberVN(soTien);
      }
    }
  },


    formatNumberVN(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '';
    return n.toLocaleString('vi-VN');
  },

  parseNumberVN(str) {
    if (str == null) return null;
    const clean = String(str)
      .replace(/\./g, '')   // bỏ dấu chấm
      .replace(/,/g, '');   // bỏ dấu phẩy
    const n = Number(clean);
    return Number.isFinite(n) ? n : null;
  },

  onTonNumberInput(field, e) {
    const raw = e.target.value;

    if (raw === '') {
      this.tonModal.form[field] = null;
      this.tonModal.form[`${field}Text`] = '';
      return;
    }

    const num = this.parseNumberVN(raw);
    this.tonModal.form[field] = num;

    // nếu user gõ thứ rác rến -> không format lại, giữ raw
    if (num == null) {
      this.tonModal.form[`${field}Text`] = raw;
    } else {
      this.tonModal.form[`${field}Text`] = this.formatNumberVN(num);
    }
  },

    suggestTonNgayChot() {
  // Nếu đang ở lọc theo tháng: lấy ngày cuối tháng trước
  if (this.monthInput) {
    const [yearStr, monthStr] = this.monthInput.split('-');
    let year = parseInt(yearStr, 10);
    let month = parseInt(monthStr, 10);
    if (!year || !month) return null;

    // tồn đầu kỳ tháng N => chốt cuối tháng N-1
    month -= 1;
    if (month < 1) {
      month = 12;
      year -= 1;
    }

    const lastDay = new Date(year, month, 0); // day 0 of next month = last day
    const yyyy = lastDay.getFullYear();
    const mm = String(lastDay.getMonth() + 1).padStart(2, '0');
    const dd = String(lastDay.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  // fallback: dựa vào filters.tuNgay -> lùi 1 ngày
  if (this.filters.tuNgay) {
    const d = new Date(this.filters.tuNgay + 'T00:00:00');
    d.setDate(d.getDate() - 1);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  return null;
},

openTonModal() {
  if (!this.filters.xeId) {
    alert('Vui lòng chọn xe trước khi nhập tồn đầu kỳ.');
    return;
  }

  const existing = this.tonDau;
  this.tonModal.form.xeId = this.filters.xeId;
  this.tonModal.form.tonDauLit = existing?.tonDauLit ?? null;

  this.tonModal.form.donGiaTon = existing?.donGiaTon ?? null;
  this.tonModal.form.donGiaTonText =
    existing?.donGiaTon != null ? this.formatNumberVN(existing.donGiaTon) : '';

  this.tonModal.form.soTienTon = existing?.soTienTon ?? null;
  this.tonModal.form.soTienTonText =
    existing?.soTienTon != null ? this.formatNumberVN(existing.soTienTon) : '';

  this.tonModal.form.odoCuoiKy = existing?.odoCuoiKy ?? null;
  this.tonModal.form.ngayChot = existing?.ngayChot ?? null;
  this.tonModal.form.ghiChu = existing?.ghiChu ?? '';

  this.tonModal.show = true;
  this.tonModal.submitting = false;
},


  async submitTonDau() {
    const f = this.tonModal.form;
    if (!f.tonDauLit || Number(f.tonDauLit) < 0) {
      alert('Tồn đầu (lít) phải >= 0');
      return;
    }
    if (!f.odoCuoiKy) {
      alert('Vui lòng nhập ODO chốt.');
      return;
    }

    this.tonModal.submitting = true;
    try {
      const payload = {
        xeId: f.xeId,
        tonDauLit: f.tonDauLit,
        donGiaTon: f.donGiaTon,
        soTienTon: f.soTienTon,
        odoCuoiKy: f.odoCuoiKy,
        ngayChot: f.ngayChot || null,
        ghiChu: f.ghiChu || null,
      };

      const saved = await XangDauApi.upsertTonDau(payload);
      this.tonDau = saved;
      this.tonModal.show = false;
      alert('Lưu tồn đầu kỳ thành công.');
    } catch (e) {
      console.error('[submitTonDau]', e);
      alert(
        e?.response?.data?.message ||
          'Lưu tồn đầu kỳ thất bại, vui lòng thử lại.'
      );
    } finally {
      this.tonModal.submitting = false;
    }
  },

closeTonModal() {
  this.tonModal.show = false;
  this.tonModal.submitting = false;
  this.tonModal.error = null;
},

async submitTonModal() {
  this.tonModal.error = null;

  if (!this.filters.xeId) {
    this.tonModal.error = 'Vui lòng chọn xe trước khi lưu tồn đầu kỳ.';
    return;
  }

  const f = this.tonModal.form;

  if (f.tonDauLit == null || Number(f.tonDauLit) < 0) {
    this.tonModal.error = 'Số lít tồn phải >= 0.';
    return;
  }

  if (f.odoCuoiKy == null || Number(f.odoCuoiKy) < 0) {
    this.tonModal.error = 'ODO chốt phải >= 0.';
    return;
  }

  let ngayChot = f.ngayChot;
  if (!ngayChot) {
    ngayChot = this.suggestTonNgayChot();
  }

  const payload = {
    xeId: this.filters.xeId,
    tonDauLit: f.tonDauLit,
    odoCuoiKy: f.odoCuoiKy,
    ngayChot: ngayChot,
    ghiChu: f.ghiChu || null,
  };

  this.tonModal.submitting = true;
  try {
    await XangDauApi.upsertTonThang(payload);
    await this.loadTonDau();  // reload tồn đầu kỳ để card + excel dùng
    this.closeTonModal();
    alert('Lưu tồn đầu kỳ thành công!');
  } catch (e) {
    console.error('[submitTonModal] error', e);
    this.tonModal.error =
      e?.response?.data?.message ||
      'Lưu tồn đầu kỳ thất bại. Vui lòng thử lại.';
  } finally {
    this.tonModal.submitting = false;
  }
},


async loadTonDau() {
  this.tonDau = null;
  this.tonCuoi = null;
  this.tonError = null;

  if (!this.filters.xeId) return;

  // Bắt buộc phải có monthInput thì mới hiểu được "tháng đang xem"
  if (!this.monthInput) return;

  const [yearStr, monthStr] = this.monthInput.split('-');
  const year = parseInt(yearStr, 10);
  const month = parseInt(monthStr, 10);
  if (!year || !month) return;

  // Tháng trước & năm trước (cho tồn ĐẦU kỳ)
  const prevMonth = month === 1 ? 12 : month - 1;
  const prevYear = month === 1 ? year - 1 : year;

  // Ngày mốc:
  // - Đầu tháng hiện tại: lấy bản chốt cuối tháng trước (tồn đầu kỳ)
  // - Đầu tháng sau: lấy bản chốt cuối tháng hiện tại (tồn cuối kỳ)
  const firstDayCur = `${year}-${String(month).padStart(2, '0')}-01`;
  const nextMonth = month === 12 ? 1 : month + 1;
  const nextYear = month === 12 ? year + 1 : year;
  const firstDayNext = `${nextYear}-${String(nextMonth).padStart(2, '0')}-01`;

  this.tonLoading = true;
  try {
    // ===== TỒN ĐẦU KỲ (chốt cuối tháng trước) =====
    let tonDau = null;
    try {
      const data = await XangDauApi.getTonDau(this.filters.xeId, firstDayCur);
      if (data && typeof data.thang === 'number' && typeof data.nam === 'number') {
        // Chỉ nhận khi nó là bản chốt của tháng trước
        if (data.thang === prevMonth && data.nam === prevYear) {
          tonDau = data;
        } else {
          // Không trùng tháng => coi như chưa chốt cho tháng này
          tonDau = null;
        }
      } else {
        tonDau = data || null;
      }
    } catch (e) {
      if (e?.response?.status !== 404) {
        console.error('[loadTonDau] tonDau error', e);
        this.tonError = e?.response?.data?.message || e.message;
      }
    }
    this.tonDau = tonDau;

    // ===== TỒN CUỐI KỲ (chốt cuối tháng hiện tại) =====
    let tonCuoi = null;
    try {
      const data2 = await XangDauApi.getTonDau(this.filters.xeId, firstDayNext);
      if (data2 && typeof data2.thang === 'number' && typeof data2.nam === 'number') {
        // Chỉ nhận khi nó là bản chốt của đúng tháng đang xem
        if (data2.thang === month && data2.nam === year) {
          tonCuoi = data2;
        } else {
          tonCuoi = null; // tháng này chưa chốt => coi như chưa có tồn cuối
        }
      } else {
        tonCuoi = null;
      }
    } catch (e) {
      if (e?.response?.status !== 404) {
        console.error('[loadTonDau] tonCuoi error', e);
        this.tonError = this.tonError || e?.response?.data?.message || e.message;
      }
    }

    this.tonCuoi = tonCuoi;
  } finally {
    this.tonLoading = false;
  }
},






openAdminCreateModal() {
  this.adminCreateModal.show = true;
  this.adminCreateModal.submitting = false;
  this.adminCreateModal.error = null;

  this.adminCreateModal.form = {
    xeId: this.filters.xeId || null,
    taiXeId: null,
    ngayDo: null,
    soTien: null,
    soTienText: '',
    soLit: null,
    donGia: null,
    donGiaText: '',
    odoKmCuoiKy: null,
    anhBienLaiUrl: '',
    anhOdoUrl: '',
    ghiChu: '',
  };

  // reset preview / upload state nếu cần
},





closeAdminCreateModal() {
  this.adminCreateModal.show = false;
  this.adminCreateModal.submitting = false;
  this.adminCreateModal.error = null;

  // clear preview biên lai
  if (
    this.adminCreateModal.bienLaiPreviewSource &&
    this.adminCreateModal.bienLaiPreviewSource.startsWith('blob:')
  ) {
    URL.revokeObjectURL(this.adminCreateModal.bienLaiPreviewSource);
  }
  this.adminCreateModal.bienLaiPreviewSource = null;
  this.adminCreateModal.bienLaiUploadError = null;

  // clear preview ODO
  if (
    this.adminCreateModal.odoPreviewSource &&
    this.adminCreateModal.odoPreviewSource.startsWith('blob:')
  ) {
    URL.revokeObjectURL(this.adminCreateModal.odoPreviewSource);
  }
  this.adminCreateModal.odoPreviewSource = null;
  this.adminCreateModal.odoUploadError = null;

  if (this.$refs.adminBienLaiFileInput) {
    this.$refs.adminBienLaiFileInput.value = '';
  }
  if (this.$refs.adminOdoFileInput) {
    this.$refs.adminOdoFileInput.value = '';
  }
},



async submitAdminCreate() {
  const f = this.adminCreateModal.form;
  this.adminCreateModal.error = null;

  // Validate tối thiểu theo BE
  if (!f.xeId) {
    this.adminCreateModal.error = 'Vui lòng chọn xe.';
    return;
  }
  if (!f.soTien || Number(f.soTien) <= 0) {
    this.adminCreateModal.error = 'Số tiền phải > 0.';
    return;
  }
  if (!f.soLit || Number(f.soLit) <= 0) {
    this.adminCreateModal.error = 'Số lít phải > 0.';
    return;
  }
  if (!f.odoKmCuoiKy || Number(f.odoKmCuoiKy) <= 0) {
    this.adminCreateModal.error = 'ODO cuối kỳ phải > 0.';
    return;
  }
  if (!f.anhBienLaiUrl || !f.anhBienLaiUrl.trim()) {
    this.adminCreateModal.error = 'Vui lòng nhập URL ảnh biên lai.';
    return;
  }
  if (!f.anhOdoUrl || !f.anhOdoUrl.trim()) {
    this.adminCreateModal.error = 'Vui lòng nhập URL ảnh ODO.';
    return;
  }

  let ngayDoIso = null;
  if (f.ngayDo) {
    ngayDoIso = new Date(f.ngayDo).toISOString();
  }

  const payload = {
    xeId: f.xeId,
    taiXeId: f.taiXeId || null,
    ngayDo: ngayDoIso,
    soTien: f.soTien,
    soLit: f.soLit,
    donGia: f.donGia,            // BE tự tính nếu null
    odoKmCuoiKy: f.odoKmCuoiKy,
    anhBienLaiUrl: f.anhBienLaiUrl,
    anhOdoUrl: f.anhOdoUrl,
    bienLaiUrls: f.anhBienLaiUrl ? [f.anhBienLaiUrl] : [],
    odoUrls: f.anhOdoUrl ? [f.anhOdoUrl] : [],
    ghiChu: f.ghiChu || null,
  };

  this.adminCreateModal.submitting = true;
  try {
    await XangDauApi.adminCreate(payload);

    // Reload list + stats
    await this.applyFiltersAndFetch(this.filters);
    await this.refreshStatsFull();

    this.closeAdminCreateModal();
    alert('Tạo phiếu xăng dầu thành công!');
  } catch (e) {
    console.error('[submitAdminCreate] error:', e);
    this.adminCreateModal.error =
      e?.response?.data?.message ||
      e?.message ||
      'Tạo phiếu thất bại. Vui lòng thử lại.';
  } finally {
    this.adminCreateModal.submitting = false;
  }
},



calcStatsFromList(list) {
  const KM_PER_LITER = 4;
  const res = {
    totalLogs: 0,
    pending: 0,
    approved: 0,
    rejected: 0,
    carCount: 0,
    sumSoTien: 0,
    sumSoLit: 0,
    avgDonGia: 0,
    sumKmThucTe: 0,
    sumKmPhaiDi: 0,
  };

  if (!Array.isArray(list) || !list.length) return res;

  const carSet = new Set();
  const groups = {};            // group theo xe
  const perLogKm = {};          // logId -> km thực tế (theo ODO)

  // Group theo biển số
  list.forEach((log) => {
    if (!log || !log.id || !log.xeBienSo) return;

    const key = this.normalizePlate(log.xeBienSo);
    if (!groups[key]) groups[key] = [];
    groups[key].push(log);

    carSet.add(log.xeBienSo);
  });

  // Tính km thực tế cho từng log trong mỗi xe
// Tính km thực tế cho từng log trong mỗi xe
Object.values(groups).forEach((arr) => {
  arr.sort((a, b) => {
    const ta = new Date(a.ngayDo || 0).getTime();
    const tb = new Date(b.ngayDo || 0).getTime();
    if (ta !== tb) return ta - tb;
    return (a.id || 0) - (b.id || 0);
  });

  // ODO chốt tồn nếu có, trùng xe
  let closingOdo = null;
  if (this.tonDau && this.tonDau.xeBienSo) {
    const tonPlate = this.normalizePlate(this.tonDau.xeBienSo);
    const listPlate = this.normalizePlate(arr[0].xeBienSo);
    if (tonPlate === listPlate) {
      const o = Number(this.tonDau.odoCuoiKy || 0);
      closingOdo = Number.isFinite(o) && o > 0 ? o : null;
    }
  }

  for (let i = 0; i < arr.length; i++) {
    const cur = arr[i];
    const next = arr[i + 1];

    const curOdo = Number(cur.odoKmCuoiKy ?? cur.odoKmDauKy ?? 0);
    let nextOdo = curOdo;

    if (next) {
      nextOdo = Number(next.odoKmCuoiKy ?? next.odoKmDauKy ?? 0);
    } else if (closingOdo != null && closingOdo > curOdo) {
      nextOdo = closingOdo;
    }

    let km = nextOdo - curOdo;
    if (!Number.isFinite(km) || km < 0) km = 0;

    perLogKm[cur.id] = km;
  }
});


  // Tính tổng
  list.forEach((log) => {
    if (!log) return;

    res.totalLogs += 1;

    if (log.trangThai === 'CHO_DUYET') res.pending += 1;
    else if (log.trangThai === 'DA_DUYET') res.approved += 1;
    else if (log.trangThai === 'TU_CHOI') res.rejected += 1;

    const soTien = Number(log.soTien || 0);
    const soLit = Number(log.soLit || 0);
    const kmTT = Number(
      perLogKm[log.id] ??
      log.kmThucTe ??
      0
    );

    res.sumSoTien += soTien;
    res.sumSoLit += soLit;
    res.sumKmThucTe += kmTT;
    res.sumKmPhaiDi += soLit * KM_PER_LITER;
  });

  res.carCount = carSet.size;
  res.avgDonGia =
    res.sumSoLit > 0 ? Math.round(res.sumSoTien / res.sumSoLit) : 0;

  return res;
},

async refreshStatsFull() {
  this.statsFull = null;

  const baseParams = {
    xeId: this.filters.xeId,
    tuNgay: this.filters.tuNgay,
    denNgay: this.filters.denNgay,
    trangThai: this.filters.trangThai,
  };

  const size = 200; // mỗi lần lôi 200 bản ghi, tuỳ ông chỉnh
  let page = 0;
  let fullList = [];

  try {
    // loop qua tất cả page
    // /api/xang-dau/list phải trả về {content, totalPages, number,...}
    while (true) {
      const data = await XangDauApi.listLogs({
        ...baseParams,
        page,
        size,
      });

      const content = data.content || [];
      fullList = fullList.concat(content);

      const totalPages = data.totalPages ?? 1;
      const currentPage = data.number ?? page;

      if (currentPage >= totalPages - 1) break;
      page = currentPage + 1;
    }

    this.statsFull = this.calcStatsFromList(fullList);
  } catch (e) {
    console.error('[refreshStatsFull] error', e);
    // fallback: dùng trang hiện tại cho đỡ trống
    this.statsFull = this.calcStatsFromList(this.items || []);
  }
},



    formatDate,
    formatDateTime,
    formatCurrency,

    // Hiển thị Km thực tế (ưu tiên value đã tính trên FE)
    displayKmThucTe(log) {
      if (!log) return '';
      const v = this.kmThucTeMap?.[log.id];
      if (v != null) return v;
      return log.kmThucTe != null ? log.kmThucTe : '';
    },

    // ===== PAYMENT MODAL =====
    openPaymentForm(log) {
      this.openPaymentModal(log);
    },

    openPaymentModal(order) {
      this.paymentModal.show = true;
      this.paymentModal.submitting = false;
      this.paymentModal.isUploading = false;
      this.paymentModal.uploadError = null;

      this.paymentModal.form = {
        id: order?.id || null,
        ghiChuThanhToan: '',
        anhChuyenKhoanUrl: null,
      };

      if (this.paymentPreviewSource && this.paymentPreviewSource.startsWith('blob:')) {
        URL.revokeObjectURL(this.paymentPreviewSource);
      }
      this.paymentPreviewSource = null;
    },

    closePaymentModal() {
      this.paymentModal.show = false;
      this.paymentModal.submitting = false;
      this.paymentModal.isUploading = false;
      this.paymentModal.uploadError = null;

      if (this.paymentPreviewSource && this.paymentPreviewSource.startsWith('blob:')) {
        URL.revokeObjectURL(this.paymentPreviewSource);
      }
      this.paymentPreviewSource = null;
    },

    triggerPaymentFileSelect() {
      if (this.paymentModal.isUploading) return;
      if (this.$refs.paymentFileInput) {
        this.$refs.paymentFileInput.click();
      }
    },

    async handlePaymentFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      await this.processPaymentImageFile(file);
      event.target.value = '';
    },

    async handlePaymentPaste(event) {
      if (this.paymentModal.isUploading) return;

      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) {
        this.paymentModal.uploadError = 'Trình duyệt không hỗ trợ dán ảnh từ clipboard.';
        return;
      }

      let file = null;

      if (clipboardData.items && clipboardData.items.length) {
        for (const item of clipboardData.items) {
          if (item.kind === 'file' && item.type.startsWith('image/')) {
            file = item.getAsFile();
            break;
          }
        }
      }

      if (!file && clipboardData.files && clipboardData.files.length) {
        const candidate = clipboardData.files[0];
        if (candidate.type && candidate.type.startsWith('image/')) {
          file = candidate;
        }
      }

      if (!file) {
        this.paymentModal.uploadError =
          'Clipboard không có ảnh. Vui lòng copy ảnh rồi dán lại.';
        return;
      }

      await this.processPaymentImageFile(file);
    },

    async processPaymentImageFile(file) {
      if (!file.type || !file.type.startsWith('image/')) {
        this.paymentModal.uploadError = 'Chỉ chấp nhận file ảnh.';
        return;
      }

      this.paymentModal.uploadError = null;
      this.paymentModal.isUploading = true;

      if (this.paymentPreviewSource && this.paymentPreviewSource.startsWith('blob:')) {
        URL.revokeObjectURL(this.paymentPreviewSource);
      }
      this.paymentPreviewSource = URL.createObjectURL(file);

      try {
        const formData = new FormData();
        formData.append('files', file);
        formData.append('folderName', 'xang_dau_payment');

        const response = await fileService.upload(formData);

        if (!response.data || !response.data.length || !response.data[0].location) {
          throw new Error('Upload thành công nhưng không nhận được URL');
        }

        const uploadedUrl = response.data[0].location;

        this.paymentModal.form.anhChuyenKhoanUrl = uploadedUrl;

        if (this.paymentPreviewSource && this.paymentPreviewSource.startsWith('blob:')) {
          URL.revokeObjectURL(this.paymentPreviewSource);
        }
        this.paymentPreviewSource = uploadedUrl;
      } catch (err) {
        console.error('Lỗi upload ảnh thanh toán:', err);
        this.paymentModal.uploadError = 'Upload ảnh thất bại, vui lòng thử lại.';
        this.paymentModal.form.anhChuyenKhoanUrl = null;

        if (this.paymentPreviewSource && this.paymentPreviewSource.startsWith('blob:')) {
          URL.revokeObjectURL(this.paymentPreviewSource);
        }
        this.paymentPreviewSource = null;
      } finally {
        this.paymentModal.isUploading = false;
      }
    },

    async submitPayment() {
      if (!this.paymentModal.form.anhChuyenKhoanUrl) {
        this.paymentModal.uploadError = 'Vui lòng đính kèm ảnh chuyển khoản.';
        return;
      }

      this.paymentModal.submitting = true;
      this.paymentModal.uploadError = null;

      try {
        await XangDauApi.markAsPaid(
          this.paymentModal.form.id,
          {
            ghiChuThanhToan: this.paymentModal.form.ghiChuThanhToan,
            anhChuyenKhoanUrl: this.paymentModal.form.anhChuyenKhoanUrl,
          }
        );

        await this.applyFiltersAndFetch(this.filters);

        this.closePaymentModal();
        alert('Xác nhận thanh toán thành công!');
      } catch (err) {
        console.error('[submitPayment error]', err);
        this.paymentModal.uploadError =
          err?.response?.data?.message ||
          'Lỗi khi xác nhận thanh toán. Vui lòng thử lại.';
      } finally {
        this.paymentModal.submitting = false;
      }
    },

    clearPaymentImage() {
      if (this.paymentPreviewSource && this.paymentPreviewSource.startsWith('blob:')) {
        URL.revokeObjectURL(this.paymentPreviewSource);
      }

      this.paymentPreviewSource = null;
      this.paymentModal.form.anhChuyenKhoanUrl = null;
      this.paymentModal.uploadError = null;

      if (this.$refs.paymentFileInput) {
        this.$refs.paymentFileInput.value = '';
      }
    },

    // ===== FILTER / TIME =====
    toYmd(d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },

    initCurrentMonthRange() {
      const now = new Date();
      const y = now.getFullYear();
      const m = now.getMonth();
      const first = new Date(y, m, 1);
      const last = new Date(y, m + 1, 0);
      this.monthInput = `${y}-${String(m + 1).padStart(2, '0')}`;
      this.filters.tuNgay = this.toYmd(first);
      this.filters.denNgay = this.toYmd(last);
    },

    setFilterMode(mode) {
      this.filterMode = mode;
      if (mode === 'MONTH') this.onMonthChange();
    },

    onMonthChange() {
      if (!this.monthInput) {
        this.filters.tuNgay = null;
        this.filters.denNgay = null;
        return;
      }
      const parts = this.monthInput.split('-');
      if (parts.length !== 2) return;
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      if (!year || !month) return;
      const first = new Date(year, month - 1, 1);
      const last = new Date(year, month, 0);
      this.filters.tuNgay = this.toYmd(first);
      this.filters.denNgay = this.toYmd(last);
    },

    changeMonth(offset) {
      if (!this.monthInput) return this.initCurrentMonthRange();
      const [yStr, mStr] = this.monthInput.split('-');
      let y = parseInt(yStr, 10);
      let m = parseInt(mStr, 10);
      if (!y || !m) return;
      m += offset;
      if (m < 1) {
        m = 12;
        y -= 1;
      } else if (m > 12) {
        m = 1;
        y += 1;
      }
      this.monthInput = `${y}-${String(m).padStart(2, '0')}`;
      this.onMonthChange();
      this.applyFilters();
    },

    async loadCauData() {
      if (!this.filters.xeId) {
        this.cauSummary = null;
        this.cauSessions = [];
        this.cauSummaryError = null;
        this.cauSessionsError = null;
        return;
      }

      const params = {
        xeId: this.filters.xeId,
        tuNgay: this.filters.tuNgay || null,
        denNgay: this.filters.denNgay || null,
      };

      this.isLoadingCauSummary = true;
      this.isLoadingCauSessions = true;
      this.cauSummaryError = null;
      this.cauSessionsError = null;

      try {
        const [summary, sessions] = await Promise.all([
          XangDauApi.getCauFuelSummary(params),
          XangDauApi.listCauByXe(params),
        ]);

        this.cauSummary = summary || null;
        this.cauSessions = Array.isArray(sessions) ? sessions : [];
      } catch (e) {
        console.error('[QuanLyXangDau] loadCauData error', e);
        this.cauSummary = null;
        this.cauSessions = [];
        const msg =
          e?.response?.data?.message ||
          e?.message ||
          'Không tải được dữ liệu cẩu hàng.';
        this.cauSummaryError = msg;
        this.cauSessionsError = msg;
      } finally {
        this.isLoadingCauSummary = false;
        this.isLoadingCauSessions = false;
      }
    },

    isCauXeOption(xe) {
      if (!xe) return false;
      const loaiRaw = (xe.loaiXe || '').toString().toLowerCase();
      const tenLoaiRaw = (xe.tenLoaiXe || '').toString().toLowerCase();
      return (
        loaiRaw === 'cau' ||
        tenLoaiRaw.includes('cẩu') ||
        tenLoaiRaw.includes('cau') ||
        !!xe.isCau
      );
    },

    // ===== EXPORT EXCEL =====
async exportToExcel() {
  if (!this.items || !this.items.length) {
    alert('Không có dữ liệu để xuất.');
    return;
  }

  try {
    const KM_PER_LITER = 4;
    const FUEL_PER_HOUR = 5;

    // đảo list: cũ -> mới (để export đọc theo thời gian tăng dần)
    const sortedItems = [...this.items].reverse();

    let sumSoTien = 0,
      sumSoLit = 0,
      sumKmThucTe = 0,
      sumKmPhaiDi = 0,
      sumKmGps = 0;

    this.items.forEach((log) => {
      const soTien = Number(log.soTien || 0);
      const soLit = Number(log.soLit || 0);
      const kmTT = Number(this.kmThucTeMap?.[log.id] ?? log.kmThucTe ?? 0);
      const kmGps = Number(this.gpsMap?.[log.id]?.km || 0);
      const kmPhai = soLit * KM_PER_LITER;

      sumSoTien += soTien;
      sumSoLit += soLit;
      sumKmThucTe += kmTT;
      sumKmPhaiDi += kmPhai;
      sumKmGps += kmGps;
    });

    const avgDonGia = sumSoLit > 0 ? Math.round(sumSoTien / sumSoLit) : 0;

    // ====== XE CẨU (nếu có) ======
    let isCauXe = false;
    let cauMinutes = 0;
    let cauHours = 0;
    let cauLit = 0;
    let cauKm = 0;

    if (this.filters.xeId) {
      const xe = this.xeOptions.find((x) => x.id === this.filters.xeId);
      if (xe && xe.tenLoaiXe && xe.tenLoaiXe.toLowerCase().includes('cẩu')) {
        isCauXe = true;
        try {
          const params = {
            xeId: this.filters.xeId,
            tuNgay: this.filters.tuNgay || null,
            denNgay: this.filters.denNgay || null,
          };

          const summary = await XangDauApi.getCauFuelSummary(params);
          if (summary) {
            cauMinutes = Number(summary.totalMinutes || 0);
            cauHours =
              summary.totalHours != null
                ? Number(summary.totalHours)
                : cauMinutes / 60;
            cauLit =
              summary.estimatedLiters != null
                ? Number(summary.estimatedLiters)
                : cauHours * FUEL_PER_HOUR;
            cauKm = cauLit * KM_PER_LITER;
          }
        } catch (e) {
          console.error('Lỗi lấy summary cẩu khi export:', e);
        }
      }
    }

    // ====== HEADER / BODY ======
    const header = [
      'STT',
      'Ngày đổ',
      'Tài xế',
      'Xe',
      'Số tiền (đ)',
      'Số lít',
      'Đơn giá (đ/lít)',
      'Km đầu kỳ',
      'Km cuối kỳ',
      'Km thực tế',
      'Km phải đi',
      'Km định vị',
    ];
    const colCount = header.length;

    const body = sortedItems.map((log, idx) => {
      const soTien = Number(log.soTien || 0);
      const soLit = Number(log.soLit || 0);
      const donGia = Number(log.donGia || 0);
      const kmDau = Number(log.odoKmDauKy || 0);
      const kmCuoi = Number(log.odoKmCuoiKy || 0);
      const kmTT = Number(this.kmThucTeMap?.[log.id] ?? log.kmThucTe ?? 0);
      const kmPhai = soLit * KM_PER_LITER;
      const kmGps = Number(this.gpsMap?.[log.id]?.km || 0);

      return [
        idx + 1 + (this.currentPage - 1) * this.size,
        this.formatDateTime(log.ngayDo),
        log.tenTaiXe,
        log.xeBienSo,
        soTien,
        soLit,
        donGia,
        kmDau,
        kmCuoi,
        kmTT,
        kmPhai,
        kmGps,
      ];
    });

    const footerRow = [
      '',
      'TỔNG',
      '',
      '',
      sumSoTien,
      sumSoLit,
      avgDonGia,
      '',
      '',
      sumKmThucTe,
      sumKmPhaiDi,
      sumKmGps,
    ];

    // ====== BUILD AOA: header -> TỒN ĐẦU KỲ (nếu có) -> body -> footer ======
    let aoa = [header];
    let tonRowIndex = null;

    if (this.tonDau) {
      const tonLit = Number(this.tonDau.tonDauLit || 0);
      const tonDonGia =
        this.tonDau.donGiaTon != null
          ? Number(this.tonDau.donGiaTon)
          : avgDonGia || 0;
      const tonSoTien =
        this.tonDau.soTienTon != null
          ? Number(this.tonDau.soTienTon)
          : tonDonGia * tonLit;
      const tonKmPhai = tonLit * KM_PER_LITER;
      const tonOdo = Number(this.tonDau.odoCuoiKy || 0);

      const tonRow = [
        '',
        'TỒN ĐẦU KỲ',
        '',
        this.tonDau.xeBienSo || '',
        tonSoTien,
        tonLit,
        tonDonGia,
        '',
        tonOdo,
        '',
        tonKmPhai,
        '',
      ];

      tonRowIndex = aoa.length; // ngay dưới header
      aoa.push(tonRow);
    }

    const bodyStartRow = aoa.length;
    aoa = [...aoa, ...body, footerRow];
    const bodyEndRow = bodyStartRow + body.length - 1;
    const footerIndex = bodyEndRow + 1;

    // ====== CỘNG THÊM DÒNG SUMMARY CẨU (CUỐI CÙNG) ======
    let summaryStartRow = null;
    if (isCauXe && (cauMinutes || cauLit || cauKm)) {
      const kmThucTeWithCau = sumKmThucTe + cauKm;
      const kmPhaiDiWithCau = sumSoLit * KM_PER_LITER;

      aoa.push([]);
      summaryStartRow = aoa.length;

      aoa.push(['', 'Phút cẩu', cauMinutes]);
      aoa.push(['', 'Giờ cẩu', cauHours]);
      aoa.push(['', 'Lít cẩu (quy đổi)', cauLit]);
      aoa.push(['', 'Km cẩu (quy đổi)', cauKm]);
      aoa.push(['', 'Km thực tế (km + cẩu)', kmThucTeWithCau]);
      aoa.push(['', 'Km phải đi (lít + lít cẩu)', kmPhaiDiWithCau]);
    }

    // ====== TẠO SHEET ======
    const ws = XLSX.utils.aoa_to_sheet(aoa);

    ws['!cols'] = [
      { wch: 6 },
      { wch: 19 },
      { wch: 20 },
      { wch: 14 },
      { wch: 15 },
      { wch: 10 },
      { wch: 16 },
      { wch: 12 },
      { wch: 12 },
      { wch: 13 },
      { wch: 13 },
      { wch: 13 },
    ];

    const borderAll = {
      top: { style: 'thin', color: { rgb: 'D9D9D9' } },
      bottom: { style: 'thin', color: { rgb: 'D9D9D9' } },
      left: { style: 'thin', color: { rgb: 'D9D9D9' } },
      right: { style: 'thin', color: { rgb: 'D9D9D9' } },
    };
    const headerStyle = {
      font: { bold: true, color: { rgb: '000000' } },
      alignment: { vertical: 'center', horizontal: 'center', wrapText: true },
      fill: { patternType: 'solid', fgColor: { rgb: 'E9ECEF' } },
      border: borderAll,
    };
    const textLeft = {
      alignment: { horizontal: 'left', vertical: 'center' },
      border: borderAll,
    };
    const textCenter = {
      alignment: { horizontal: 'center', vertical: 'center' },
      border: borderAll,
    };
    const numRight = (fmt) => ({
      alignment: { horizontal: 'right', vertical: 'center' },
      border: borderAll,
      numFmt: fmt,
    });
    const moneyRight = {
      alignment: { horizontal: 'right', vertical: 'center' },
      border: borderAll,
      numFmt: '#,##0',
    };
    const totalRowStyle = {
      font: { bold: true },
      fill: { patternType: 'solid', fgColor: { rgb: 'F8F9FA' } },
      border: borderAll,
    };
    const cauLabelStyle = {
      font: { bold: true },
      alignment: { horizontal: 'left', vertical: 'center' },
      fill: { patternType: 'solid', fgColor: { rgb: 'E9ECEF' } },
      border: borderAll,
    };
    const cauValueStyle = {
      alignment: { horizontal: 'right', vertical: 'center' },
      border: borderAll,
      numFmt: '#,##0.0',
    };
    const cauValueHighlight = {
      ...cauValueStyle,
      fill: { patternType: 'solid', fgColor: { rgb: 'FFF2CC' } },
      font: { bold: true },
    };

    // ====== STYLE: HEADER ======
    for (let c = 0; c < colCount; c++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[cellRef]) ws[cellRef].s = headerStyle;
    }

    // ====== STYLE: BODY ======
    for (let r = bodyStartRow; r <= bodyEndRow; r++) {
      for (let c = 0; c < colCount; c++) {
        const cellRef = XLSX.utils.encode_cell({ r, c });
        if (!ws[cellRef]) continue;

        if (c === 0) ws[cellRef].s = textCenter;
        else if (c === 1) ws[cellRef].s = textLeft;
        else if (c === 2) ws[cellRef].s = textLeft;
        else if (c === 3) ws[cellRef].s = textLeft;
        else if (c === 4) ws[cellRef].s = moneyRight;
        else if (c === 5) ws[cellRef].s = numRight('#,##0.00');
        else if (c === 6) ws[cellRef].s = numRight('#,##0');
        else if (c === 7) ws[cellRef].s = numRight('#,##0');
        else if (c === 8) ws[cellRef].s = numRight('#,##0');
        else if (c === 9) ws[cellRef].s = numRight('#,##0');
        else if (c === 10) ws[cellRef].s = numRight('#,##0');
        else if (c === 11) ws[cellRef].s = numRight('#,##0.0');
      }
    }

    // ====== STYLE: FOOTER (TỔNG) ======
    for (let c = 0; c < colCount; c++) {
      const cellRef = XLSX.utils.encode_cell({ r: footerIndex, c });
      if (!ws[cellRef]) continue;

      ws[cellRef].s = { ...totalRowStyle };

      if (c === 4) ws[cellRef].s = { ...ws[cellRef].s, ...moneyRight };
      if (c === 5) ws[cellRef].s = { ...ws[cellRef].s, ...numRight('#,##0.00') };
      if ([9, 10, 11].includes(c))
        ws[cellRef].s = { ...ws[cellRef].s, ...numRight('#,##0.0') };

      if (c === 1) ws[cellRef].s = { ...ws[cellRef].s, ...textLeft };
      if ([0, 2, 3, 7, 8].includes(c))
        ws[cellRef].s = { ...ws[cellRef].s, ...textCenter };
    }

    // ====== STYLE: TỒN ĐẦU KỲ (row ngay dưới header) ======
    if (tonRowIndex != null) {
      const tonBase = {
        font: { bold: true },
        fill: { patternType: 'solid', fgColor: { rgb: 'FFF2CC' } },
        border: borderAll,
      };

      for (let c = 0; c < colCount; c++) {
        const cellRef = XLSX.utils.encode_cell({ r: tonRowIndex, c });
        if (!ws[cellRef]) continue;

        // mặc định
        let style = { ...tonBase, ...textCenter };

        if ([1, 3].includes(c)) {
          style = { ...tonBase, ...textLeft };
        } else if ([4, 5, 6, 8, 10].includes(c)) {
          style = {
            ...tonBase,
            alignment: { horizontal: 'right', vertical: 'center' },
          };
          if (c === 4) style.numFmt = '#,##0';
          if (c === 5) style.numFmt = '#,##0.00';
          if (c === 6) style.numFmt = '#,##0';
          if (c === 8) style.numFmt = '#,##0';
          if (c === 10) style.numFmt = '#,##0';
        }

        ws[cellRef].s = style;
      }
    }

    // ====== STYLE: SUMMARY CẨU ======
    if (summaryStartRow !== null) {
      const first = summaryStartRow;
      const last = summaryStartRow + 5;

      for (let r = first; r <= last; r++) {
        const labelCell = XLSX.utils.encode_cell({ r, c: 1 });
        const valueCell = XLSX.utils.encode_cell({ r, c: 2 });

        if (ws[labelCell]) ws[labelCell].s = cauLabelStyle;

        if (ws[valueCell]) {
          if (r === last || r === last - 1) {
            ws[valueCell].s = cauValueHighlight;
          } else {
            ws[valueCell].s = cauValueStyle;
          }
        }
      }
    }

    // ====== GHI FILE ======
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'XangDau');

    const tu = this.filters.tuNgay || '';
    const den = this.filters.denNgay || '';
    let suffix = '';
    if (tu && den) suffix = `_${tu}_to_${den}`;
    else if (tu) suffix = `_${tu}_from`;
    else if (den) suffix = `__to_${den}`;
    const fileName = `xang_dau${suffix}.xlsx`;

    XLSX.writeFile(wb, fileName);
  } catch (e) {
    console.error('Export Excel error:', e);
    alert('Xuất Excel thất bại. Vui lòng kiểm tra lại cấu hình xlsx-js-style.');
  }
},




    getStatusBadge(status) {
      switch (status) {
        case 'CHO_DUYET':
          return 'badge-warning';
        case 'DA_DUYET':
          return 'badge-success';
        case 'DA_THANH_TOAN':
          return 'badge-info';
        case 'TU_CHOI':
          return 'badge-danger';
        default:
          return 'badge-light';
      }
    },

    formatTrangThai(status) {
      switch (status) {
        case 'CHO_DUYET':
          return 'Chờ duyệt';
        case 'DA_DUYET':
          return 'Đã duyệt';
        case 'DA_THANH_TOAN':
          return 'Đã thanh toán';
        case 'TU_CHOI':
          return 'Đã từ chối';
        default:
          return status;
      }
    },

async applyFilters() {
  await this.applyFiltersAndFetch(this.filters);
  this.loadCauData();
  this.refreshStatsFull();
  await this.loadTonDau();   // <<=== THÊM

},


async applyFilterTab(status) {
  this.filters.trangThai = status;
  await this.applyFiltersAndFetch(this.filters);
  this.loadCauData();
  this.refreshStatsFull();
    await this.loadTonDau();   // <<=== THÊM

},

    changeSize(newSize) {
      this.setSize(Number(newSize));
    },
    goPage(p) {
      if (p < 1 || p > this.totalPages || p === this.currentPage) return;
      this.setPage(p);
    },

    async openDetail(logId) {
      this.showModal = true;
      this.formError = null;
      document.body.style.overflow = 'hidden';
      await this.fetchLogDetail(logId);
      await this.fetchEditHistory(logId);
    },

    closeModal() {
      this.showModal = false;
      this.clearLogDetail();
      document.body.style.overflow = '';
    },

    async doApprove(logId) {
      this.formError = null;
      if (!confirm('Bạn chắc chắn muốn DUYỆT báo cáo này?')) return;
      try {
        await this.approveLog(logId);
        alert('Duyệt thành công!');
      } catch (e) {
        this.formError = this.detailError || 'Lỗi khi duyệt.';
      }
    },

    async doReject(logId) {
      this.formError = null;
      const lyDo = prompt('Vui lòng nhập lý do Từ chối (bắt buộc):');
      if (!lyDo || lyDo.trim() === '') {
        alert('Bạn phải nhập lý do từ chối.');
        return;
      }
      try {
        await this.rejectLog(logId, lyDo.trim());
        alert('Từ chối thành công!');
      } catch (e) {
        this.formError = this.detailError || 'Lỗi khi từ chối.';
      }
    },

    openEvidence(type, startIndex = 0) {
      if (!this.currentLogDetail) return;
      let list = [];
      if (type === 'BIEN_LAI') {
        if (this.currentLogDetail.bienLaiUrls?.length)
          list = this.currentLogDetail.bienLaiUrls.slice();
        else if (this.currentLogDetail.anhBienLaiUrl)
          list = [this.currentLogDetail.anhBienLaiUrl];
      } else if (type === 'ODO') {
        if (this.currentLogDetail.odoUrls?.length)
          list = this.currentLogDetail.odoUrls.slice();
        else if (this.currentLogDetail.anhOdoUrl)
          list = [this.currentLogDetail.anhOdoUrl];
      }
      if (!list.length) return;
      this.lb.imgs = list;
      this.lb.index = Math.max(0, Math.min(startIndex, list.length - 1));
      this.lb.visible = true;
    },

    openLightboxFromList(imgs, index = 0) {
      if (!imgs || !imgs.length) return;
      this.lb.imgs = imgs.slice();
      this.lb.index = Math.max(0, Math.min(index, imgs.length - 1));
      this.lb.visible = true;
    },

    // ==== CHỈNH SỬA ====
    openEditForm(log) {
      const d = log;
      const dt = d && d.ngayDo ? this.toDatetimeLocalValue(d.ngayDo) : null;
      this.editModal.form = {
        id: d.id,
        soTien: d.soTien ?? null,
        soLit: d.soLit ?? null,
        donGia: d.donGia ?? null,
        odoKmDauKy: d.odoKmDauKy ?? null,
        odoKmCuoiKy: d.odoKmCuoiKy ?? null,
        ngayDo: dt,
        ghiChu: d.ghiChu || '',
        lyDo: '',
        anhUrls: [],
      };
      this.editModal.localFiles = [];
      this.editModal.error = null;
      this.editModal.show = true;
    },

    closeEditForm() {
      this.editModal.show = false;
      this.editModal.localFiles = [];
      this.editModal.error = null;
    },

    toDatetimeLocalValue(isoString) {
      const d = new Date(isoString);
      if (Number.isNaN(d.getTime())) return null;
      const yyyy = d.getFullYear();
      const MM = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
    },

    async submitEdit() {
      this.editModal.error = null;
      const f = this.editModal.form;

      if (!f.lyDo || !f.lyDo.trim()) {
        this.editModal.error = 'Vui lòng nhập lý do chỉnh sửa.';
        return;
      }
      if (f.soTien != null && Number(f.soTien) <= 0) {
        this.editModal.error = 'Số tiền phải > 0.';
        return;
      }
      if (f.soLit != null && Number(f.soLit) <= 0) {
        this.editModal.error = 'Số lít phải > 0.';
        return;
      }
      if (f.odoKmCuoiKy != null && Number(f.odoKmCuoiKy) < 0) {
        this.editModal.error = 'ODO cuối kỳ không hợp lệ.';
        return;
      }
      if (f.odoKmDauKy != null && Number(f.odoKmDauKy) < 0) {
        this.editModal.error = 'ODO đầu kỳ không hợp lệ.';
        return;
      }

      let donGia = f.donGia;
      if (donGia != null) {
        const dgNum = Number(donGia);
        if (
          dgNum > 0 &&
          dgNum < 1000 &&
          f.soTien != null &&
          Number(f.soTien) >= 100000
        ) {
          donGia = Math.round(dgNum * 1000);
        }
      }

      const payload = {
        soTien: f.soTien,
        soLit: f.soLit,
        donGia: donGia,
        odoKmDauKy: f.odoKmDauKy,
        odoKmCuoiKy: f.odoKmCuoiKy,
        ngayDo: f.ngayDo || null,
        ghiChu: f.ghiChu || null,
        lyDo: f.lyDo,
        anhUrls: f.anhUrls || [],
      };

      try {
        this.editModal.submitting = true;
        await this.correctLog(f.id, payload);
        alert('Cập nhật chỉnh sửa thành công!');
        await this.fetchLogDetail(f.id);
        await this.fetchEditHistory(f.id);
        this.closeEditForm();
      } catch (err) {
        console.error(err);
        this.editModal.error =
          'Chỉnh sửa thất bại. Vui lòng thử lại.';
      } finally {
        this.editModal.submitting = false;
      }
    },

    // Chuẩn hoá biển số
    normalizePlate(plate) {
      if (!plate) return '';
      return plate.replace(/\s|\./g, '');
    },

    formatGpsTime(isoString) {
      if (!isoString) return '';
      const s = isoString.replace('T', ' ').substring(0, 16);
      return s + ':00';
    },

     toLocalGpsTime(dateOrString) {
    const d = dateOrString instanceof Date ? dateOrString : new Date(dateOrString);
    if (Number.isNaN(d.getTime())) return '';

    const yyyy = d.getFullYear();
    const MM   = String(d.getMonth() + 1).padStart(2, '0');
    const dd   = String(d.getDate()).padStart(2, '0');
    const hh   = String(d.getHours()).padStart(2, '0');     // local hour
    const mm   = String(d.getMinutes()).padStart(2, '0');   // local minute

    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:00`;
  },

async fetchGpsChunk(plate, beginTime, endTime) {
  const baseUrl = 'https://api.gpsbinhminh.vn/Vehicle/GpsHistoryV3';

  const params = new URLSearchParams({
    licensePlate: plate,
    beginTime,
    endTime,
    username: this.gpsConfig.username,
    pwd: this.gpsConfig.password,
  });

  const res = await fetch(`${baseUrl}?${params.toString()}`);
  const text = await res.text();

  if (!text || !text.trim()) {
    return { km: 0, rawBegin: null, rawEnd: null };
  }

  let json;
  try {
    json = JSON.parse(text);
  } catch (e) {
    console.error('GPS parse error:', e, text);
    throw new Error('GPS lỗi JSON');
  }

  // Trường hợp Status = 0, thời gian không hợp lệ, hoặc Data rỗng
  const list = Array.isArray(json.Data) ? json.Data : [];
  if (!list.length) {
    return { km: 0, rawBegin: null, rawEnd: null };
  }

  const first = list[0];
  const last = list[list.length - 1];

  const startTotal = Number(first.TotalDistance || 0);
  const endTotal   = Number(last.TotalDistance  || 0);

  let delta = endTotal - startTotal;
  if (!Number.isFinite(delta) || delta < 0) delta = 0;

  return {
    km: delta / 1000,
    rawBegin: first.UpdateTime || null,
    rawEnd: last.UpdateTime || null,
  };
},

// GPS cho 1 log
// GPS cho 1 log
async fetchGpsForLog(log) {
  if (!log || !log.id || !log.xeBienSo || !log.ngayDo) return;

  const key = log.id;

  // Đã có kết quả km rồi thì thôi
  if (this.gpsMap[key] && this.gpsMap[key].km != null) {
    return;
  }

  const plate = this.normalizePlate(log.xeBienSo);

  // Lấy tất cả log cùng xe, sort theo thời gian tăng dần
  const sameLogs = (this.items || [])
    .filter(
      (l) =>
        l.xeBienSo &&
        this.normalizePlate(l.xeBienSo) === plate &&
        l.ngayDo
    )
    .sort((a, b) => new Date(a.ngayDo) - new Date(b.ngayDo));

  const idx = sameLogs.findIndex((l) => l.id === log.id);
  if (idx === -1) {
    // Không tìm thấy trong list hiện tại -> bó tay
    return;
  }

  const startDate = new Date(log.ngayDo);
  let endDate = null;

  if (idx < sameLogs.length - 1) {
    // Có log sau -> dùng thời gian log sau làm mốc
    endDate = new Date(sameLogs[idx + 1].ngayDo);
  } else {
    // ===== LOG CUỐI CÙNG TRONG FILTER =====
    // Ưu tiên 1: ngày chốt tồn cuối kỳ (tonCuoi.ngayChot)
    if (this.tonCuoi && this.tonCuoi.ngayChot) {
      const d = new Date(this.tonCuoi.ngayChot + 'T23:59:00');
      if (d > startDate) {
        endDate = d;
      }
    }

    // Ưu tiên 2: ngày filter kết thúc (denNgay) nếu hợp lệ
    if (!endDate && this.filters && this.filters.denNgay) {
      const d = new Date(this.filters.denNgay + 'T23:59:00');
      if (d > startDate) {
        endDate = d;
      }
    }

    // Fallback: cộng thêm 1 ngày cho đỡ bị khóa cứng
    if (!endDate) {
      endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
    }
  }

  // Bảo vệ: nếu endDate <= startDate thì bỏ qua, tránh query GPS ngược đời
  if (!endDate || endDate <= startDate) {
    this.gpsMap = {
      ...this.gpsMap,
      [key]: {
        km: null,
        loading: false,
        error: 'Khoảng thời gian GPS không hợp lệ',
      },
    };
    return;
  }

  // Init state cho UI
  this.gpsMap = {
    ...this.gpsMap,
    [key]: {
      km: null,
      loading: true,
      error: null,
      beginTime: this.toLocalGpsTime(startDate),
      endTime:   this.toLocalGpsTime(endDate),
    },
  };

  try {
    let totalKm = 0;
    let segStart = new Date(startDate);
    let firstRaw = null;
    let lastRaw  = null;

    while (segStart < endDate) {
      let segEnd = new Date(segStart.getTime() + MAX_GPS_RANGE_MS - 60 * 1000);
      if (segEnd > endDate) segEnd = endDate;

      const beginTime = this.toLocalGpsTime(segStart);
      const endTime   = this.toLocalGpsTime(segEnd);

      const chunk = await this.fetchGpsChunk(plate, beginTime, endTime);

      if (chunk && chunk.km != null) {
        totalKm += chunk.km;
        if (!firstRaw) firstRaw = chunk.rawBegin || null;
        if (chunk.rawEnd) lastRaw = chunk.rawEnd;
      }

      // sang đoạn tiếp theo, nhảy thêm 1 phút để tránh trùng
      segStart = new Date(segEnd.getTime() + 60 * 1000);
    }

    this.gpsMap = {
      ...this.gpsMap,
      [key]: {
        km: totalKm,
        loading: false,
        error: null,
        beginTime: this.toLocalGpsTime(startDate),
        endTime:   this.toLocalGpsTime(endDate),
        rawBegin: firstRaw,
        rawEnd:   lastRaw,
      },
    };
  } catch (err) {
    console.error('GPS fetch error', err);
    this.gpsMap = {
      ...this.gpsMap,
      [key]: {
        km: null,
        loading: false,
        error: 'Fetch lỗi',
      },
    };
  }
},




    prefetchGpsForAll(list) {
      const logs = (list || this.items || []).filter(
        (l) =>
          l &&
          l.trangThai === 'DA_DUYET' &&
          l.xeBienSo &&
          l.ngayDo,
      );

      logs.forEach((log) => {
        this.fetchGpsForLog(log);
      });
    },
  },

async mounted() {
  this.initCurrentMonthRange();
  await this.applyFiltersAndFetch(this.filters);
  this.fetchOptionsIfNeeded();
  this.loadCauData();
  this.refreshStatsFull();
  await this.loadTonDau();   // <<=== THÊM

},

};
</script>

<style scoped>
.page-wrapper {}
.container-fluid { padding-top: 1.5rem; padding-bottom: 1.5rem; }
.btn-block{ margin-top: 0 !important; }
.card { box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }

/* Header stats pills */
.header-stats { gap: 6px; }
.header-stat-pill {
  background: #f8f9fa; border-radius: 999px; padding: 4px 10px;
  display: flex; flex-direction: column; align-items: flex-end;
}
.header-stat-pill .label { font-size: 11px; line-height: 1.1; color: #6c757d; }
.header-stat-pill .value { font-size: 13px; font-weight: 600; }

/* Quick stats */
.quick-stats-row { row-gap: 6px; }
.quick-stat-item .label { font-size: 11px; color: #6c757d; }
.quick-stat-item .value { font-size: 13px; font-weight: 600; }

/* Table */
.table td, .table th { vertical-align: middle; }
.table thead th { background-color: #e9ecef; border-bottom-width: 1px; font-size: 0.85rem; }
.table-hover tbody tr:hover { background-color: #f8f9fa; }
.table-sm-mobile td, .table-sm-mobile th { padding: 0.4rem 0.5rem; }
.max-w-120 { max-width: 120px; }

/* Modal */
.modal { overflow-y: auto; }
.modal-body { max-height: 80vh; overflow-y: auto; }

/* Tabs */
.card-tabs .nav-link { color: #495057; padding: 0.6rem 0.75rem; font-weight: 500; font-size: 0.9rem; }
.card-tabs .nav-link.active { color: #0d6efd; border-bottom: 3px solid #0d6efd; background-color: transparent; }

/* Badge */
.badge { padding: 0.35em 0.55em; font-size: 0.8rem; font-weight: 500; }
.badge-success { background-color: #198754; color: #fff; }
.badge-danger  { background-color: #dc3545; color: #fff; }
.badge-warning { background-color: #ffc107; color: #000; }
.badge-info    { background-color: #0dcaf0; color: #000; }
.badge-light   { background-color: #f8f9fa; color: #000; border: 1px solid #dee2e6; }

/* Evidence grid */
.evidence-list { display: flex; flex-wrap: wrap; justify-content: center; margin: 0 -4px; }
.evidence-item { margin: 4px; text-align: center; }
.evidence-thumb { width: 120px; height: 90px; object-fit: cover; cursor: zoom-in; }
.evidence-thumb-single { max-width: 100%; max-height: 220px; object-fit: contain; cursor: zoom-in; }

/* Toolbar */
.toolbar { gap: 8px; }

/* Mobile tweaks */
@media (max-width: 576px) {
  .evidence-thumb { width: 90px; height: 68px; }
  .header-stats { width: 100%; justify-content: flex-start; }
  .header-stat-pill { align-items: flex-start; }
}

.upload-dropzone {
  border: 2px dashed #cbd5e0;
  border-radius: 0.5rem;
  background: #f9fafb;
  padding: 0.75rem;
  cursor: pointer;
}
.upload-dropzone.is-uploading {
  opacity: 0.7;
}
.preview-thumb {
  border-radius: 0.5rem;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dee2e6;
  display: inline-block;
  max-width: 100%;
  position: relative;
}
.clickable-thumb {
  cursor: zoom-in;
}
.preview-remove-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 0.15rem 0.35rem;
  font-size: 0.7rem;
  line-height: 1;
  border-radius: 999px;
}
</style>
